import _ from "lodash";

import React, { memo, useRef, useState, useEffect } from "react";
import PropTypes from "prop-types";
import classes from "./PypEvaluationV2.scss";
import { connect } from "react-redux";
import {
  generateNestedSelectedData,
  getPYPElementSetFromNodes,
  generateRandomId,
  getSubjectStandardWithCode,
  onEnterOrSpaceKeyDown,
  getStyleStrippedText,
} from "Utils";
import {
  getCriteriaSetOfPypType,
  checkCriteriaSetOfPypTypeInLevels,
  filteredCriteriaSetsMemoized,
  getGradeScalesByRootNodeIdMemoized,
} from "modules/Services";
import {
  pypElementMapping,
  pypElementSetMapping,
} from "Constants/plannerElementMappings";
import {
  deletePypElementRating,
  createIbPypElementRating,
} from "AssessmentEvaluation/modules/AssessmentEvaluationModule";
import { getOrganizationConstantsFromCache } from "modules/CommonGraphqlHelpers";
import { colors } from "Constants";
import { fontStyles } from "@toddle-edu/ds-theme";
import MiddleBody from "ClassProgressSummary/components/RatingHistory/MiddleBody";

import Checkbox from "UIComponents/Checkbox";
import EmptyField from "UIComponents/EmptyField";
import I18nHOC from "UIComponents/I18nHOC";
import UIModal from "UIComponents/UIModal";
import AIJustification from "UIComponents/AIJustification";
import { compose, graphql } from "lib/apolloClient";
import {
  CURRICULUM_TYPE_PYP,
  CURRICULUM_TYPE_UBD,
  ELEMENT_TYPE_UBD_LEARNING_STANDARD,
  ELEMENT_TYPE_UBD_ATL,
  ELEMENT_TYPE_UBD_SUBJECT,
  ELEMENT_TYPE_MYP_ATL,
  CURRICULUM_TYPE_MYP,
  ELEMENT_TYPE_MYP_LEARNING_STANDARD,
  ELEMENT_TYPE_MYP_SUBJECT,
  ELEMENT_TYPE_DP_SUBJECT_STANDARD,
  ELEMENT_TYPE_DP_SUBJECT,
  ELEMENT_TYPE_DP_SYLLABUS,
  ELEMENT_TYPE_MYP_OBJECTIVES,
  ELEMENT_TYPE_MYP_KEY_CONCEPT,
  ELEMENT_TYPE_MYP_RELATED_CONCEPT,
  ELEMENT_TYPE_MYP_LEARNER_PROFILE,
  CURRICULUM_TYPE_DP,
  ELEMENT_TYPE_DP_ATL,
  ELEMENT_TYPE_UBD_KEY_CONCEPT,
  ELEMENT_TYPE_UBD_FOCUS_AREA,
  ELEMENT_TYPE_UBD_LEARNER_PROFILE,
  ELEMENT_TYPE_UbD_THEME,
  ELEMENT_TYPE_MYP_SPECIFIED_CONCEPT,
  PLANNER_ELEMENT_MYP_GLOBAL_CONTEXT,
  ELEMENT_TYPE_MYP_FOCUS_AREA,
  ELEMENT_TYPE_PYP_LEARNING_STANDARD,
  ELEMENT_TYPE_PYP_ACTION,
  ELEMENT_TYPE_PYP_ATL,
  ELEMENT_TYPE_PYP_KEY_CONCEPT,
  ELEMENT_TYPE_PYP_LEARNER_PROFILE,
  ELEMENT_TYPE_DP_LEARNER_PROFILE,
  NODE_TYPE_IB_PYP_CURRICULUM_PROGRAM,
} from "Constants/stringConstants";
import classNames from "classnames";
import {
  updatePost,
  updatePostRatingsCollectively,
} from "Post/modules/PostModule";
import { getAllTaggableElements } from "modules/TaggableElementsUtils";
import { IconButton, SelectDropdown, Tooltip } from "@toddle-edu/ds-web";
import { compareRatingObjects } from "AppComponents/Post/utils";
import {
  CloseOutlined,
  InformationOutlined,
  InsightsOutlined,
} from "@toddle-edu/ds-icons";
import { ArrowContainer, Popover } from "@toddle-edu/react-tiny-popover";
import ACLStore from "lib/aclStore";
import {
  updateEvaluationData,
  getIsMediaManagerRoute,
  setElementRatingMutationInProgress,
} from "ClassRoom/modules/ClassRoomModule";
import { getIsAIGeneratingResponseForTool } from "ClassRoom/modules/ClassRoomSelectors";
import {
  getLearningCourseStandardsForRatingQuery,
  getCurriculumStandardsForRatingQuery,
  getDataSetQuery,
  getPypPlannerElementNodesQuery,
  getPlannerElementNodesQuery,
} from "ClassRoom/modules/ClassRoomQuery";
import {
  getIsNewGradingSetupEnabled,
  getIsSubjectStandard,
  getIsEnableLearningGoalsEvaluationInNewGradingSetup,
  getIsRatingSubjectOrCourseWise,
  getPlannerElementsToEvaluate,
} from "ClassRoom/modules/utils";
import {
  getStandardRubricCoveredNodeIds,
  syncAssessmentFieldsWithStandardRubric,
} from "AssessmentEvaluation/modules/AssessmentToolUtils";
import ConditionalWrapper from "Utils/ConditionalWrapper";
import {
  getLinesOfInquiryNodes,
  getInquiryQuestionsNodes,
  getFlattenedNodes,
  STANDARD_UIDS,
  FIELD_KEY_TO_PLANNER_ELEMENT_TYPE,
} from "Assessments/modules/Utils";
import { getUserIdentifierName } from "Utils/GetFormattedUserName";
import { observeElementInViewport } from "observe-element-in-viewport";
import { useCallbackRef } from "Utils/CustomHooks";
import SkeletonLoader from "UIComponents/SkeletonLoader";
import { getSelectedLearningCourseId } from "LearningCourse/modules/Utils";
import { getSelectedCurriculumId } from "modules/CommonSelectors";
import { createStandardLabelsMap } from "AssessmentEvaluation/modules/Utils";
import {
  getIsCourseBasedGradingEnabled,
  getIsLearningCoursesEnabled,
  getIsSubjectBasedGradingEnabled,
} from "Teacher/routes/LearningCourses/modules/Utils";
import { getSettingValue } from "modules/PermissionModule";
import { isGradeScaleApplicableAtDepth } from "Gradebook/modules/GradeScaleDepthUtils";

const PARENT_CHILD_INDENTATION = 24;
const PARENT_CHILD_INDENTATION_V2 = 12;
const BLANK_ARRAY = [];
const EMPTY_OBJECT = {};
const levelsLabelStyleMapping = ["h1Label", "h2Label", "h3Label", "h4Label"];
const LOADER_COLUMN_COUNT = 4;

const styles = {
  overlayInnerStyle: {
    maxWidth: "240px",
  },
  starsTwoFilledIconStyle: {
    color: "var(--interactive-tertiary)",
  },
};

const iconBtnProp = { type: "plain" };

export const PLANNER_ELEMENT_FIELD_UID_MAP = {
  learningStandardUBD: ELEMENT_TYPE_UBD_LEARNING_STANDARD,
  atlsUBD: ELEMENT_TYPE_UBD_ATL,
  conceptsUBD: ELEMENT_TYPE_UBD_KEY_CONCEPT,
  focusAreasUBD: ELEMENT_TYPE_UBD_FOCUS_AREA,
  lpUBD: ELEMENT_TYPE_UBD_LEARNER_PROFILE,
  themeUBD: ELEMENT_TYPE_UbD_THEME,
  relatedConceptsMYP: ELEMENT_TYPE_MYP_RELATED_CONCEPT,
  specifiedConcepts: ELEMENT_TYPE_MYP_SPECIFIED_CONCEPT,
  learningStandardMYP: ELEMENT_TYPE_MYP_LEARNING_STANDARD,
  atlsMYP: ELEMENT_TYPE_MYP_ATL,
  objectivesMYP: ELEMENT_TYPE_MYP_OBJECTIVES,
  conceptsMYP: ELEMENT_TYPE_MYP_KEY_CONCEPT,
  globalContextMYP: PLANNER_ELEMENT_MYP_GLOBAL_CONTEXT,
  lpMYP: ELEMENT_TYPE_MYP_LEARNER_PROFILE,
  focusAreasMYP: ELEMENT_TYPE_MYP_FOCUS_AREA,
  benchmarks: ELEMENT_TYPE_PYP_LEARNING_STANDARD,
  action: ELEMENT_TYPE_PYP_ACTION,
  atls: ELEMENT_TYPE_PYP_ATL,
  concepts: ELEMENT_TYPE_PYP_KEY_CONCEPT,
  lp: ELEMENT_TYPE_PYP_LEARNER_PROFILE,
  subjectStandardDP: ELEMENT_TYPE_DP_SUBJECT_STANDARD,
  atlDP: ELEMENT_TYPE_DP_ATL,
  learnerProfileDP: ELEMENT_TYPE_DP_LEARNER_PROFILE,
  syllabusContentDP: ELEMENT_TYPE_DP_SYLLABUS,
  aimDP: "DP_AIM",
  objectivesDP: "DP_OBJECTIVES",
  interdisciplinaryCriteriaMYP: ELEMENT_TYPE_MYP_OBJECTIVES,
};

const parsePlannerElementSetsGradeScales = data =>
  _.transform(
    _.get(data, "plannerElementNodeSets.edges", []),
    (acc, { node }) => {
      const type = _.get(node, "type");
      const nodeSetId = _.get(node, "id");
      const gradeScales = _.get(node, "gradeScales", []);

      if (type) {
        acc[type] = _.map(gradeScales, gs => ({
          ...gs,
          plannerElementNodeSetId: nodeSetId,
        }));
      }
    },
    {}
  );

const getPypRootLevelStyleMapping = params => {
  const { sourceFrom } = params;

  switch (sourceFrom) {
    case "CLASSROOM": {
      return {
        BENCHMARK: "h1Label",
        CONCEPT: "h3Label",
        LEARNER_PROFILE: "h3Label",
        DP_LEARNER_PROFILE: "h3Label",
        ATL: "h2Label",
        UBD_ATL: "h2Label",
        UBD_LEARNING_STANDARD: "h1Label",
        MYP_ATL: "h2Label",
        DP_ATL: "h3Label",
        MYP_LEARNING_STANDARD: "h1Label",
        DP_SUBJECT_STANDARD: "h2Label",
      };
    }
    default:
      return {
        BENCHMARK: "h1Label",
        CONCEPT: "h4Label",
        LEARNER_PROFILE: "h4Label",
        DP_LEARNER_PROFILE: "h4Label",
        ATL: "h2Label",
        UBD_ATL: "h2Label",
        UBD_LEARNING_STANDARD: "h1Label",
        MYP_ATL: "h2Label",
        DP_ATL: "h4Label",
        MYP_LEARNING_STANDARD: "h1Label",
        DP_SUBJECT_STANDARD: "h1Label",
      };
  }
};

const getCreateRatingParams = ({
  rootNodeId,
  curriculumProgramType,
  type,
  subjectId,
  set,
  isNewGradingSetupEnabled,
}) => {
  if (isNewGradingSetupEnabled) {
    if (
      getIsSubjectBasedGradingEnabled() &&
      (getIsSubjectStandard({ type }) || getIsRatingSubjectOrCourseWise())
    ) {
      return getIsSubjectStandard({ type })
        ? { subjectId: _.get(set, "subjectId") }
        : { subjectId };
    }

    return {};
  }

  switch (curriculumProgramType) {
    case CURRICULUM_TYPE_MYP: {
      switch (type) {
        case ELEMENT_TYPE_MYP_ATL:
        case ELEMENT_TYPE_MYP_LEARNER_PROFILE:
          return { subjectId };
        default:
          return { subjectId: rootNodeId };
      }
    }

    case CURRICULUM_TYPE_DP: {
      return { subjectId };
    }

    default:
      return {};
  }
};

const getRootNodeId = ({
  curriculumProgramType,
  rootNodeId,
  ibPYPElementType,
}) => {
  if (ibPYPElementType === ELEMENT_TYPE_MYP_LEARNER_PROFILE) return null;

  switch (curriculumProgramType) {
    case CURRICULUM_TYPE_MYP:
    case CURRICULUM_TYPE_UBD:
      return rootNodeId;
    default:
      return null;
  }
};

const CriteriaSetOptionsPopup = ({
  setOptions,
  setValue,
  onClickOption,
  t,
  gradingHistoryObject,
  set,
  nodeLabel,
  nodeCode,
  criteriaDescriptorState,
  setCriteriaDescriptorState,
  parentContainerRef,
  infoIconSize,
  shouldCloseOnValueChange,
  criteriaDescriptorIconStyle,
  subjectIds,
  isNewGradingSetupEnabled,
}) => {
  const [isRatingboxOpen, setIsRatingboxOpen] = useState(false);
  const {
    showDescriptiorModal,
    showRatingDescriptorModal,
  } = criteriaDescriptorState;

  const gradingViewRef = useRef();
  const {
    academicCriteriaSetId,
    elementId,
    elementType,
    studentId,
  } = gradingHistoryObject;
  const options = _.map(setOptions, opt => {
    return {
      abbreviation: opt?.abbreviation,
      value: opt.id,
      key: opt.id,
    };
  });

  const onRatingboxClick = () => {
    setIsRatingboxOpen(!isRatingboxOpen);
    setCriteriaDescriptorState({
      showDescriptiorModal: showDescriptiorModal,
      showRatingDescriptorModal,
      selectedCriteriaSet: set,
    });
  };

  const onRatingValueChange = e => {
    const currentClickedValue = e?.target?.value || -1;
    if (setValue == currentClickedValue) {
      onClickOption(null);
    } else {
      onClickOption(currentClickedValue);
    }

    if (shouldCloseOnValueChange) {
      setIsRatingboxOpen(false);
    }
  };

  const closeCriteriaDescriptorModal = e => {
    e?.stopPropagation();
    setCriteriaDescriptorState({
      showDescriptiorModal: false,
      showRatingDescriptorModal: false,
      selectedCriteriaSet: {},
    });
  };
  const popupContainerClass = classNames(
    { [classes.popUpContainer]: true },
    { [classes.popUpContainerSm]: true }
  );
  const currentRatingBoxClasses = classNames(
    { [classes.currentRatingBox]: true },
    { [classes.selectedCurrentRatingBox]: isRatingboxOpen }
  );
  const currentRatingAbbreviation = _.get(
    _.find(options, option => option?.key == setValue),
    "abbreviation",
    "-"
  );

  const onHandleKeyDownRatingBox = e => {
    onEnterOrSpaceKeyDown(e, onRatingboxClick);
  };

  return (
    <div
      className={classes.ratingWithHistoryContainer}
      ref={parentContainerRef}
    >
      <div
        className={currentRatingBoxClasses}
        ref={gradingViewRef}
        onClick={onRatingboxClick}
        tabIndex={0}
        onKeyDown={onHandleKeyDownRatingBox}
      >
        {currentRatingAbbreviation}
      </div>
      {/* Following segment will show a popup of grading history of particular criteria */}
      {isRatingboxOpen && (
        <Popover
          isOpen={true}
          align={"start"}
          positions={["left"]}
          padding={0}
          reposition={true}
          onClickOutside={e => setIsRatingboxOpen(false)}
          containerStyle={{ zIndex: 1500, marginTop: "-42px" }}
          content={({ position, childRect, popoverRect, nudgedTop }) => {
            return (
              <ArrowContainer
                position={position}
                childRect={childRect}
                popoverRect={popoverRect}
                arrowColor={colors.white}
                arrowSize={10}
                arrowStyle={{ zIndex: "10", marginTop: "32px" }}
                arrowClassName="popover-arrow"
              >
                <div
                  className={popupContainerClass}
                  style={!_.isNil(studentId) ? { minHeight: "508px" } : {}}
                >
                  <div className={classes.popupHeader}>
                    <div className={classes.popupHeaderSetLabel}>
                      {_.get(
                        set,
                        "label",
                        isNewGradingSetupEnabled
                          ? t("academicSetup:grade_scale")
                          : t("common:criteria_set")
                      )}
                      <div
                        className={classes.criteriaDescriptorIcon}
                        style={criteriaDescriptorIconStyle}
                        onClick={() =>
                          setCriteriaDescriptorState({
                            selectedCriteriaSet:
                              showRatingDescriptorModal == false ? set : {},
                            showRatingDescriptorModal: !showRatingDescriptorModal,
                          })
                        }
                      >
                        <InformationOutlined
                          size={infoIconSize}
                          variant="subtle"
                        />
                      </div>
                    </div>
                    <div className={classes.popupHeaderSetDescription}>
                      {getSubjectStandardWithCode({
                        label: nodeLabel,
                        code: nodeCode,
                      })}
                    </div>
                  </div>
                  <div className={classes.popupRatingValuesContainer}>
                    {_.map(options, option => {
                      const inputId = `${academicCriteriaSetId}_${elementId}_${option?.key}`;
                      return (
                        <label
                          key={option?.key}
                          className={classes.popupRatingContainer}
                          htmlFor={inputId}
                        >
                          <input
                            id={inputId}
                            type="checkbox"
                            value={option?.key}
                            name={`${academicCriteriaSetId}_${elementId}`}
                            onChange={onRatingValueChange}
                            checked={setValue == option?.key}
                          />
                          <div className={classes.popupRatingbox} tabIndex={0}>
                            {_.get(option, "abbreviation", "")}
                          </div>
                        </label>
                      );
                    })}
                  </div>
                  {!_.isNil(studentId) && !showRatingDescriptorModal && (
                    <MiddleBody
                      academicCriteriaSetId={academicCriteriaSetId}
                      elementId={elementId}
                      elementType={elementType}
                      studentId={studentId}
                      isPopUp={true}
                      showBasicHistoryList={true}
                      subjectIds={subjectIds}
                    />
                  )}
                  {showRatingDescriptorModal ? (
                    <div className={classes.descriptorPopupContainer}>
                      <RatingCriteriaDescriptor
                        criteriaDescriptorState={criteriaDescriptorState}
                        closeCriteriaDescriptorModal={
                          closeCriteriaDescriptorModal
                        }
                        isNewGradingSetupEnabled={isNewGradingSetupEnabled}
                      />
                    </div>
                  ) : null}
                </div>
              </ArrowContainer>
            );
          }}
          childrenRef={{ current: gradingViewRef?.current }}
          isChildrenRefPassed={true}
        ></Popover>
      )}
    </div>
  );
};

const CriteriaSetOptionDropdown = memo(
  ({
    setOptions,
    setValue,
    onClickOption,
    t,
    set,
    menuKey,
    setMenuKey,
    gradingHistoryObject,
    infoIconSize,
    criteriaDescriptorState = {},
    setCriteriaDescriptorState,
    shouldCloseOnValueChange,
    nodeLabel,
    nodeCode,
    criteriaDescriptorIconStyle,
    subjectIds,
    showUpdatedDesign,
    aiSelectedValue,
    aiEvaluationLabel,
    isNewGradingSetupEnabled,
  }) => {
    const [selectedElementId, setSelectedElementId] = useState("");
    const gradingViewRef = useRef(null);
    const [criteriaSetLocalValue, setCriteriaSetLocalValue] = useState(null);

    const setId = set?.id;

    const { showRatingDescriptorModal } = criteriaDescriptorState;

    const {
      academicCriteriaSetId,
      elementId,
      elementType,
      studentId,
    } = gradingHistoryObject;

    const options = _.map(setOptions, opt => {
      const label = _.get(opt, "abbreviation");
      return {
        label,
        value: _.get(opt, "id"),
        key: _.get(opt, "id"),
        subtitle: label === aiEvaluationLabel ? t("ai:ai_grade") : "",
      };
    });

    if (criteriaSetLocalValue) {
      options.push({ label: "-", value: null, key: null });
    }

    const value =
      _.find(options, {
        value: criteriaSetLocalValue,
      }) || null;

    useEffect(() => {
      if (setValue != criteriaSetLocalValue) {
        setCriteriaSetLocalValue(setValue);
      }
    }, [setValue]);

    const handleClickOption = e => {
      setCriteriaSetLocalValue(e.value);
      setMenuKey("");
      setTimeout(() => {
        onClickOption(e.value);
      });
    };

    const handleAcceptAIRatingValue = () => {
      if (aiSelectedValue) {
        const { academicCriteriaValue } = aiSelectedValue;
        const academicCriteriaValueId = academicCriteriaValue?.id;

        handleClickOption({ value: academicCriteriaValueId });
      }
    };

    const onRatingValueChange = e => {
      const currentClickedValue = e?.target?.value;

      const updatedValue = _.isEmpty(currentClickedValue)
        ? null
        : currentClickedValue;
      setCriteriaSetLocalValue(updatedValue);
      setTimeout(() => {
        onClickOption(updatedValue);
      });

      if (shouldCloseOnValueChange) {
        setSelectedElementId("");
      }
    };

    const closeCriteriaDescriptorModal = e => {
      e?.stopPropagation();
      setCriteriaDescriptorState({
        showDescriptiorModal: false,
        showRatingDescriptorModal: false,
        selectedCriteriaSet: {},
      });
    };

    const onBlur = () => {
      setMenuKey("");
    };

    const onKeyUp = e => {
      e.stopPropagation();
    };

    const onKeyDown = e => {
      e.stopPropagation();
      if (e?.key === "Enter") {
        const menuKey = `${setId}_${elementId}`;
        setMenuKey(menuKey);
      }
    };

    const gradingHistoryIconClass = classNames({
      [classes.gradingHistoryIcon]: true,
      [classes.gradingHistoryIconVisible]: selectedElementId === elementId,
    });

    const selectDropdownClasses = classNames({
      [classes.selectDropdown]: true,
      [classes.selectDropdownAiOption]: aiSelectedValue,
    });

    const popupRatingBoxClass = classNames({
      [classes.popupRatingbox]: true,
      [classes.popupRatingBoxAiOption]: !_.isEmpty(aiSelectedValue),
    });

    return (
      <div className={classes.dropdownContainer}>
        <SelectDropdown
          options={options}
          size={"small"}
          placeholder={t("journal:rate")}
          onChange={handleClickOption}
          closeMenuOnSelect={true}
          value={value}
          isCreatable={false}
          isClearable={false}
          menuIsOpen={
            !_.isEmpty(menuKey)
              ? menuKey === `${setId}_${elementId}`
              : undefined
          }
          onFocus={handleAcceptAIRatingValue}
          onKeyDown={onKeyDown}
          onKeyUp={onKeyUp}
          onBlur={onBlur}
          className={selectDropdownClasses}
          dsVersion={showUpdatedDesign ? "2.0" : "1.0"}
          useDynamicOverlayWidth={true}
        />

        <IconButton
          icon={<InsightsOutlined />}
          size={showUpdatedDesign ? "small" : "x-small"}
          variant={showUpdatedDesign ? "neutral" : "plain"}
          onClick={() => {
            if (_.isEmpty(selectedElementId)) {
              setSelectedElementId(elementId);
            } else {
              setSelectedElementId("");
            }
          }}
          ref={gradingViewRef}
          className={gradingHistoryIconClass}
          isActivated={!_.isEmpty(selectedElementId)}
          tabIndex={-1}
          dsVersion={showUpdatedDesign ? "2.0" : "1.0"}
          {...(showUpdatedDesign ? iconBtnProp : {})}
        />

        {!_.isEmpty(selectedElementId) ? (
          <Popover
            isOpen={true}
            align={"center"}
            positions={["left", "right", "top", "bottom"]}
            padding={0}
            reposition={true}
            onClickOutside={() => setSelectedElementId("")}
            containerStyle={{ zIndex: 1500 }}
            content={({ position, childRect, popoverRect }) => {
              const popupContainerClass = classNames(
                classes.popUpContainer,
                classes.popUpContainerSm
              );

              return (
                <ArrowContainer
                  position={position}
                  childRect={childRect}
                  popoverRect={popoverRect}
                  arrowColor={colors.white}
                  arrowSize={10}
                  arrowStyle={{ zIndex: "10" }}
                  arrowClassName="popover-arrow"
                >
                  <div
                    className={popupContainerClass}
                    style={!_.isNil(studentId) ? { height: "fit-content" } : {}}
                  >
                    <div className={classes.popupHeader}>
                      <div className={classes.popupHeaderSetLabelContainer}>
                        <div className={classes.popupHeaderSetLabel}>
                          {_.get(
                            set,
                            "label",
                            getIsNewGradingSetupEnabled()
                              ? t("academicSetup:grade_scale")
                              : t("common:criteria_set")
                          )}
                          <div
                            className={classes.criteriaDescriptorIcon}
                            style={criteriaDescriptorIconStyle}
                            onClick={() =>
                              setCriteriaDescriptorState({
                                selectedCriteriaSet:
                                  showRatingDescriptorModal == false ? set : {},
                                showRatingDescriptorModal: !showRatingDescriptorModal,
                              })
                            }
                          >
                            <InformationOutlined
                              size={infoIconSize}
                              variant="subtle"
                            />
                          </div>
                        </div>
                        <div className={classes.aiEvaluationLabelContainer}>
                          {!_.isEmpty(aiEvaluationLabel) ? (
                            <>
                              <div className="text-body">
                                {t("ai:ai_grade")}
                              </div>
                              <div className={classes.dot} />
                            </>
                          ) : null}
                          <div className="text-body">{aiEvaluationLabel}</div>
                        </div>
                      </div>

                      <div className={classes.popupHeaderSetDescription}>
                        {getSubjectStandardWithCode({
                          label: nodeLabel,
                          code: nodeCode,
                        })}
                      </div>
                    </div>
                    <div className={classes.popupRatingValuesContainer}>
                      {_.map(options, option => {
                        const inputId = `${academicCriteriaSetId}_${elementId}_${option?.key}`;
                        return (
                          <label
                            key={option?.key}
                            className={classes.popupRatingContainer}
                            htmlFor={inputId}
                          >
                            <input
                              id={inputId}
                              type="checkbox"
                              value={option?.key}
                              name={`${academicCriteriaSetId}_${elementId}`}
                              onChange={onRatingValueChange}
                              checked={criteriaSetLocalValue == option?.key}
                            />
                            <div className={popupRatingBoxClass} tabIndex={0}>
                              {_.get(option, "label", "")}
                            </div>
                          </label>
                        );
                      })}
                    </div>
                    {!_.isNil(studentId) && !showRatingDescriptorModal && (
                      <MiddleBody
                        academicCriteriaSetId={academicCriteriaSetId}
                        elementId={elementId}
                        elementType={elementType}
                        studentId={studentId}
                        isPopUp={true}
                        showBasicHistoryList={true}
                        containerTitleStyle={{
                          fontSize: "1.6rem",
                          lineHeight: "2.4rem",
                          color: colors.textDefault,
                          ...fontStyles.demiBold,
                        }}
                        subjectIds={subjectIds}
                      />
                    )}
                    {showRatingDescriptorModal ? (
                      <div className={classes.descriptorPopupContainer}>
                        <RatingCriteriaDescriptor
                          criteriaDescriptorState={criteriaDescriptorState}
                          closeCriteriaDescriptorModal={
                            closeCriteriaDescriptorModal
                          }
                          isNewGradingSetupEnabled={isNewGradingSetupEnabled}
                        />
                      </div>
                    ) : null}
                  </div>
                </ArrowContainer>
              );
            }}
            childrenRef={{ current: gradingViewRef?.current }}
            isChildrenRefPassed={true}
          ></Popover>
        ) : null}
      </div>
    );
  }
);

CriteriaSetOptionDropdown.displayName = "CriteriaSetOptionDropdown";

const RatingCriteriaDescriptor = memo(props => {
  const {
    criteriaDescriptorState,
    closeCriteriaDescriptorModal,
    hideCriteriaTitle = false,
    isNewGradingSetupEnabled = false,
  } = props;

  const values = isNewGradingSetupEnabled
    ? _.get(
        criteriaDescriptorState,
        "selectedCriteriaSet.gradeScaleEntityDetails.0.gradeScaleValues",
        []
      )
    : _.get(
        criteriaDescriptorState,
        "selectedCriteriaSet.academicCriteriaValues",
        []
      );

  return (
    <React.Fragment>
      {!hideCriteriaTitle && (
        <div className={classes.descriptorHeading}>
          <div className="heading-5">
            {isNewGradingSetupEnabled
              ? _.get(
                  criteriaDescriptorState,
                  "selectedCriteriaSet.displayName",
                  "Grade scale"
                )
              : _.get(
                  criteriaDescriptorState,
                  "selectedCriteriaSet.label",
                  "Criteria"
                )}
          </div>
          <IconButton
            icon={<CloseOutlined />}
            variant="plain"
            onClick={closeCriteriaDescriptorModal}
          />
        </div>
      )}
      <div className={classes.descriptorItemsContainer}>
        {_.map(values, (value, index) => {
          return (
            <div
              key={_.get(value, "id")}
              className={classes.descriptorCriteriaValueItem}
            >
              <div className={classes.descriptorAbbreviation}>
                {`${_.get(value, "abbreviation", "Default")} :`}
              </div>
              <div className={classes.descriptorDetails}>
                <div className={classes.descriptorFullForm}>
                  {_.get(value, "label", "Default")}
                </div>
                <div className={classes.descriptorDescription}>
                  {_.get(value, "description", "No description available.")}
                </div>
              </div>
              {hideCriteriaTitle && index == 0 && (
                <IconButton
                  icon={<CloseOutlined />}
                  variant="plain"
                  onClick={closeCriteriaDescriptorModal}
                  style={{ transform: "translateY(-10px)" }}
                />
              )}
            </div>
          );
        })}
      </div>
    </React.Fragment>
  );
});

RatingCriteriaDescriptor.displayName = "RatingCriteriaDescriptor";

const CriteriaSetContainer = memo(
  ({
    isComplete,
    criteriaSet,
    createPypElementRating,
    deletePypElementRating,
    checkCriteriaSetOfPypTypeInLevels,
    getStudentElementRatingValueOfCriteriaSet,
    t,
    isMinimalDesign,
    isJournalPostRating,
    updatePost,
    node,
    elementRatings,
    postAllStudentRatings,
    parentId,
    studentId,
    updatePostRatingsCollectively,
    criteriaDescriptorState,
    setCriteriaDescriptorState,
    parentContainerRef,
    subjectId,
    rootNodeId,
    curriculumProgramType,
    infoIconSize,
    shouldCloseOnValueChange,
    showDropdown,
    sourceFrom,
    updateIsTextFocus,
    criteriaDescriptorIconStyle,
    subjectIds,
    userId,
    showUpdatedDesign,
    setCriteriaSetContainerRef,
    isCriteriaSetContainerVisible,
    criteriaSetHeaderLabelPreviewStyle = {},
    showCriteriaDescriptorButton,
    isNewGradingSetupEnabled,
    isGeneratingAIResponse,
    academicTermId,
    onAcceptAIEvaluation,
    learningCourseId,
    plannerElementType,
    plannerElementSetsByPlannerElementType,
    isCriteriaSetLoading,
    gradeScaleDepthLevels,
  }) => {
    const [menuKey, setMenuKey] = useState("");

    const handleAcceptAIEvaluation = ({ aiSelectedValue }) => {
      const {
        ibPYPElementId,
        ibPYPElementType,
        academicCriteriaValue,
        academicCriteriaSet,
      } = aiSelectedValue;
      const academicCriteriaValueId = academicCriteriaValue?.id;
      const academicCriteriaSetId = academicCriteriaSet?.id;

      onAcceptAIEvaluation({
        ibPypElementId: ibPYPElementId,
        academicTermId,
        ibPYPElementType,
        academicCriteriaValueId,
        academicCriteriaSetId,
      });
    };

    const _onClickOption = ({
      criteriaValue,
      setId,
      set,
      setOptions,
      aiSelectedValue,
    }) => {
      if (isJournalPostRating) {
        if (!_.isNil(criteriaValue)) {
          const setOption = _.find(
            setOptions,
            value => value.id == criteriaValue
          );
          // subjectId is required for MYP class summary
          const subjectIdParams = getCreateRatingParams({
            subjectId,
            rootNodeId,
            curriculumProgramType,
            type: _.get(node, "ibPlannerElementType", ""),
            isNewGradingSetupEnabled,
            set,
          });

          const newPypElementRating = {
            id: generateRandomId(),
            ibPYPElementId: _.get(node, "id", undefined),
            ibPYPElementType: _.get(node, "ibPlannerElementType", ""),
            value: null,
            academicCriteriaSet: set,
            academicCriteriaValue: setOption,
            studentId: studentId,
            learningCourseId: getIsCourseBasedGradingEnabled()
              ? learningCourseId
              : undefined,
            ...subjectIdParams,
            __typename: "IBPYPElementRating",
          };

          // ParentId is only available when user is editing the already created post.
          if (parentId != undefined) {
            newPypElementRating.parentId = parentId;
          }

          // repeat rating object for all students, in collective rating mode
          if (
            studentId == undefined &&
            !_.isEqual(newPypElementRating?.studentId, userId)
          ) {
            updatePostRatingsCollectively({
              currentRatings: _.filter(
                postAllStudentRatings,
                rating => !_.isEqual(rating?.studentId, userId)
              ),
              newRating: newPypElementRating,
            });
          } else {
            const currentIndex = _.findIndex(postAllStudentRatings, rating => {
              return compareRatingObjects({
                rating1: rating,
                rating2: newPypElementRating,
              });
            });
            const updatedElementRatings = [...postAllStudentRatings];

            // Update exsiting rating
            if (currentIndex != -1) {
              newPypElementRating.academicTerm = _.get(
                updatedElementRatings,
                [currentIndex, "academicTerm"],
                null
              );
              updatedElementRatings[currentIndex] = newPypElementRating;
            } else updatedElementRatings.push(newPypElementRating);
            updatePost({
              ibPYPElementRatings: [
                ..._.filter(
                  updatedElementRatings,
                  rating => !_.isEqual(rating?.studentId, userId)
                ),
              ],
            });
          }
        } else {
          const updatedElementRatings = [...postAllStudentRatings];

          const deletedRatings =
            studentId == undefined
              ? // In case of collective, remove rating for all students
                _.remove(updatedElementRatings, rating => {
                  return compareRatingObjects({
                    rating1: rating,
                    rating2: node,
                    shouldCompareStudent: false,
                    nodeTypeObjectVariable: 2,
                    setId: setId,
                  });
                })
              : // In case of individual mode, remove specific student rating
                _.remove(updatedElementRatings, rating => {
                  return (
                    compareRatingObjects({
                      rating1: rating,
                      rating2: node,
                      shouldCompareStudent: false,
                      nodeTypeObjectVariable: 2,
                      setId: setId,
                    }) &&
                    _.get(
                      rating,
                      "studentId",
                      _.get(rating, "student.id", undefined)
                    ) == studentId
                  );
                });
          // Remove exsiting rating
          if (_.size(deletedRatings, 0) > 0) {
            updatePost({
              ibPYPElementRatings: [
                ..._.filter(
                  updatedElementRatings,
                  rating => !_.isEqual(rating?.studentId, userId)
                ),
              ],
            });
          }
        }
      } else {
        // Handle non-journal post rating
        if (!_.isNil(criteriaValue)) {
          createPypElementRating({
            criteriaValue,
            setId,
            sourceFrom,
            isDeleteAiRatings: !_.isEmpty(aiSelectedValue),
            set,
          });

          // call bulk mutation to delete ai rating
          if (aiSelectedValue) {
            handleAcceptAIEvaluation({ aiSelectedValue });
          }
        } else {
          deletePypElementRating({
            setId,
          });
        }
      }
    };

    const onClickOfSetIcon = set => {
      setCriteriaDescriptorState({
        selectedCriteriaSet: set,
        showDescriptiorModal: true,
      });
    };
    const setValueClass = classNames({
      [classes.setValue]: true,
      [classes.setValuePreview]: isMinimalDesign,
    });
    const setClass = classNames({
      [classes.set]: true,
      [classes.setPreview]: isMinimalDesign,
    });

    // Style for classroom source
    let rightContainerStyle = {};
    if (sourceFrom === "CLASSROOM") {
      rightContainerStyle = {
        display: "grid",
        gridTemplateColumns: `repeat(${
          isCriteriaSetLoading ? LOADER_COLUMN_COUNT : _.size(criteriaSet)
        },1fr)`,
      };
    }

    const onIconSetClick = set => () => {
      onClickOfSetIcon(set);
    };

    return (
      <div
        className={classes.rightContainer}
        style={rightContainerStyle}
        ref={setCriteriaSetContainerRef}
      >
        {isCriteriaSetLoading
          ? _.times(LOADER_COLUMN_COUNT, index => (
              <div key={index} className={setClass}>
                <SkeletonLoader height="18px" width="80px" />
              </div>
            ))
          : isCriteriaSetContainerVisible && !isGeneratingAIResponse
          ? _.map(criteriaSet, set => {
              const showCriteria = checkCriteriaSetOfPypTypeInLevels({
                setId: set.id,
              });
              const setValue = getStudentElementRatingValueOfCriteriaSet({
                setId: set.id,
              });
              // Create grade scale options with defensive error handling
              let setOptions = [];
              if (isNewGradingSetupEnabled) {
                const gradeScaleEntity = _.first(
                  _.get(set, "gradeScaleEntityDetails", [])
                );
                const gradeScaleValues = _.get(
                  gradeScaleEntity,
                  "gradeScaleValues",
                  []
                );

                // Map grade scale values to the format expected by components
                setOptions = _.map(gradeScaleValues, el => ({
                  abbreviation: el.abbreviation,
                  id: el.id,
                }));
              } else {
                setOptions = set.academicCriteriaValues || [];
              }

              const gradingHistoryObject = {
                academicCriteriaSetId: _.get(set, "id", undefined),
                elementId: _.get(node, "id", undefined),
                elementType: _.get(node, "ibPlannerElementType", ""),
                studentId,
              };

              const aiSelectedValue = _.find(elementRatings, rating => {
                return (
                  _.get(rating, "ibPYPElementId") === _.get(node, "id") &&
                  _.get(rating, "ibPYPElementType") ===
                    _.get(node, "ibPlannerElementType") &&
                  _.get(rating, "academicCriteriaSet.id") === set.id &&
                  rating?.creatorType === "AI" &&
                  !rating?.isDeleted
                );
              });

              const aiEvaluationLabel = _.get(
                _.find(elementRatings, rating => {
                  return (
                    _.get(rating, "ibPYPElementId") === _.get(node, "id") &&
                    _.get(rating, "ibPYPElementType") ===
                      _.get(node, "ibPlannerElementType") &&
                    _.get(rating, "academicCriteriaSet.id") === set.id &&
                    rating?.creatorType === "AI"
                  );
                }),
                "academicCriteriaValue.abbreviation"
              );

              // Check if this element is gradable under the new grading setup
              const canLearningGoalBeGraded =
                getIsEnableLearningGoalsEvaluationInNewGradingSetup() &&
                _.get(
                  plannerElementSetsByPlannerElementType,
                  [
                    plannerElementType,
                    node?.id,
                    "dataSetNodeWrapper",
                    "properties",
                    "isGraded",
                  ],
                  true
                );

              _.get(
                node,
                "plannerElementNodeWrapper.properties.isGradedStandard",
                false
              );

              const isDepthApplicable = isGradeScaleApplicableAtDepth({
                gradeScaleDepthLevels,
                plannerElementNodeSetId: set.plannerElementNodeSetId,
                gradeScaleId: set.id,
                depth: node?.depth,
              });

              const canBeGraded =
                (getIsSubjectStandard({ type: node?.type })
                  ? _.get(node, "isGradedStandard") &&
                    _.get(node, "gradingType") === "INDIVIDUAL"
                  : canLearningGoalBeGraded) &&
                isDepthApplicable &&
                _.size(setOptions) > 0 &&
                isNewGradingSetupEnabled;
              const criteriaSetHeaderLabelClass = classNames({
                [classes.criteriaSetHeaderLabel]: !showUpdatedDesign,
                [classes.criteriaSetHeaderLabelPreview]:
                  !isComplete && !showUpdatedDesign,
                ["text-label"]: showUpdatedDesign,
                [classes.criteriaSetHeaderLabelV2]: showUpdatedDesign,
                [classes.criteriaSetHeaderLabelPreviewV2]:
                  !isComplete && showUpdatedDesign,
              });
              return (
                <div className={setClass} key={set.id}>
                  {showCriteria || canBeGraded ? (
                    !isComplete ? (
                      showDropdown ? (
                        <CriteriaSetOptionDropdown
                          set={set}
                          t={t}
                          setValue={setValue}
                          aiSelectedValue={aiSelectedValue}
                          setOptions={setOptions}
                          onClickOption={value => {
                            _onClickOption({
                              criteriaValue: value,
                              setId: set.id,
                              setOptions,
                              set,
                              aiSelectedValue,
                            });
                          }}
                          menuKey={menuKey}
                          setMenuKey={setMenuKey}
                          gradingHistoryObject={gradingHistoryObject}
                          updateIsTextFocus={updateIsTextFocus}
                          infoIconSize={infoIconSize}
                          criteriaDescriptorState={criteriaDescriptorState}
                          setCriteriaDescriptorState={
                            setCriteriaDescriptorState
                          }
                          shouldCloseOnValueChange={shouldCloseOnValueChange}
                          nodeLabel={_.get(node, "label", "")}
                          nodeCode={_.get(node, "code", "")}
                          criteriaDescriptorIconStyle={
                            criteriaDescriptorIconStyle
                          }
                          subjectIds={subjectIds}
                          showUpdatedDesign={showUpdatedDesign}
                          aiEvaluationLabel={aiEvaluationLabel}
                          isNewGradingSetupEnabled={isNewGradingSetupEnabled}
                        />
                      ) : (
                        <CriteriaSetOptionsPopup
                          t={t}
                          setValue={setValue}
                          set={set}
                          nodeLabel={_.get(node, "label", "")}
                          nodeCode={_.get(node, "code", "")}
                          onClickOfSetIcon={() => onClickOfSetIcon(set)}
                          onClickOption={value => {
                            _onClickOption({
                              criteriaValue: value,
                              setId: set.id,
                              setOptions,
                              set,
                              aiSelectedValue,
                            });
                          }}
                          setOptions={setOptions}
                          isMinimalDesign={isMinimalDesign}
                          gradingHistoryObject={gradingHistoryObject}
                          criteriaDescriptorState={criteriaDescriptorState}
                          setCriteriaDescriptorState={
                            setCriteriaDescriptorState
                          }
                          parentContainerRef={parentContainerRef}
                          infoIconSize={infoIconSize}
                          shouldCloseOnValueChange={shouldCloseOnValueChange}
                          criteriaDescriptorIconStyle={
                            criteriaDescriptorIconStyle
                          }
                          subjectIds={subjectIds}
                          isNewGradingSetupEnabled={isNewGradingSetupEnabled}
                        />
                      )
                    ) : (
                      <div className={setValueClass}>
                        {_.get(
                          _.find(setOptions, { id: setValue }),
                          "abbreviation",
                          "-"
                        )}
                      </div>
                    )
                  ) : isNewGradingSetupEnabled &&
                    _.get(node, "levelId") === 0 &&
                    _.get(node, "depth") === 1 ? (
                    <div className={setClass} key={set.id}>
                      <div
                        className={criteriaSetHeaderLabelClass}
                        style={criteriaSetHeaderLabelPreviewStyle}
                      >
                        <ConditionalWrapper
                          wrapper={
                            <Tooltip
                              placement={"left"}
                              tooltip={_.get(set, "displayName")}
                              overlayInnerStyle={styles.overlayInnerStyle}
                              dsVersion={showUpdatedDesign ? "2.0" : "1.0"}
                            />
                          }
                          condition={_.size(_.get(set, "displayName")) > 16}
                          type={"wrapperAsElement"}
                        >
                          <div className={classes.setLabel}>
                            {_.get(set, "displayName")}
                          </div>
                        </ConditionalWrapper>
                        {showCriteriaDescriptorButton && (
                          <div
                            className={classes.criteriaDescriptorIcon}
                            style={criteriaDescriptorIconStyle}
                            onClick={onIconSetClick(set)}
                          >
                            <InformationOutlined
                              size={infoIconSize}
                              variant="subtle"
                            />
                          </div>
                        )}
                      </div>
                    </div>
                  ) : null}
                </div>
              );
            })
          : _.map(criteriaSet, set => (
              <div key={set?.id} className={setClass}>
                <SkeletonLoader width="100px" height="32px" />
              </div>
            ))}
      </div>
    );
  }
);

CriteriaSetContainer.displayName = "CriteriaSetContainer";

const CriteriaSetHeaderRow = memo(
  ({
    criteriaSet,
    headerLabel,
    isMinimalDesign,
    levelType,
    showCriteriaDescriptorButton,
    setCriteriaDescriptorState,
    showCriteriaColumns,
    isComplete,
    leftContainerStyle,
    customHeaderLabelStyle,
    criteriaSetHeaderLabelPreviewStyle,
    infoIconSize,
    criteriaSetHeaderRowStyle,
    rowContainerStyle,
    sourceFrom,
    criteriaDescriptorIconStyle,
    showUpdatedDesign,
    headerRowLeftContainerStyle,
    isNewGradingSetupEnabled,
    isCriteriaSetLoading,
  }) => {
    const criteriaSetHeaderRowClass = classNames({
      [classes.criteriaSetHeaderRow]: true,
      [classes.criteriaSetHeaderRowPreview]: isMinimalDesign,
      [classes.criteriaSetHeaderSingle]:
        isMinimalDesign && levelType == "single",
    });
    const criteriaSetHeaderLabelClass = classNames({
      [classes.criteriaSetHeaderLabel]: !showUpdatedDesign,
      [classes.criteriaSetHeaderLabelPreview]:
        !isComplete && !showUpdatedDesign,
      ["text-label"]: showUpdatedDesign,
      [classes.criteriaSetHeaderLabelV2]: showUpdatedDesign,
      [classes.criteriaSetHeaderLabelPreviewV2]:
        !isComplete && showUpdatedDesign,
    });
    const leftContainerClass = classNames({
      [classes.leftContainer]: true,
      [classes.leftContainerPreview]: isMinimalDesign,
    });
    const setClass = classNames({
      [classes.set]: true,
      [classes.setPreview]: isMinimalDesign,
    });

    const headerLabelStyle = {
      fontSize: "1.8rem",
      fontWeight: "700",
      color: colors.textDefault,
      justifyContent: "flex-start",
    };

    const onClickOfSetIcon = set => {
      setCriteriaDescriptorState({
        showDescriptiorModal: true,
        selectedCriteriaSet: set,
      });
    };

    let rightContainerStyle = {};
    if (sourceFrom === "CLASSROOM") {
      rightContainerStyle = {
        display: "grid",
        gridTemplateColumns: `repeat(${
          isCriteriaSetLoading ? LOADER_COLUMN_COUNT : _.size(criteriaSet)
        },1fr)`,
      };
    }

    let criteriaSetHeaderLabelStyle = {};
    if (isMinimalDesign) {
      criteriaSetHeaderLabelStyle = {
        ...(!showUpdatedDesign ? headerLabelStyle : {}),
        ...customHeaderLabelStyle,
      };
    }

    return (
      <div
        className={criteriaSetHeaderRowClass}
        style={criteriaSetHeaderRowStyle}
      >
        <div
          className={leftContainerClass}
          style={{
            width: `${Math.max(40, 80 - 10 * criteriaSet.length)}%`,
            ...leftContainerStyle,
            ...headerRowLeftContainerStyle,
          }}
        >
          <div
            className={criteriaSetHeaderLabelClass}
            style={criteriaSetHeaderLabelStyle}
          >
            <span
              dangerouslySetInnerHTML={{
                __html: getStyleStrippedText({
                  text: headerLabel,
                  type: "SANITIZE_DANGER_HTML_PARAGRAPH",
                }),
              }}
            />
          </div>
        </div>
        <div className={classes.rightContainer} style={rightContainerStyle}>
          {isCriteriaSetLoading
            ? _.times(LOADER_COLUMN_COUNT, index => (
                <div key={index} className={setClass}>
                  <SkeletonLoader height="18px" width="80px" />
                </div>
              ))
            : showCriteriaColumns
            ? _.map(criteriaSet, set => {
                const setLabel = _.get(
                  set,
                  isNewGradingSetupEnabled ? "displayName" : "label",
                  ""
                );

                return (
                  <div className={setClass} key={set.id}>
                    <div
                      className={criteriaSetHeaderLabelClass}
                      style={criteriaSetHeaderLabelPreviewStyle}
                    >
                      <ConditionalWrapper
                        wrapper={
                          <Tooltip
                            placement={"left"}
                            tooltip={setLabel}
                            overlayInnerStyle={styles.overlayInnerStyle}
                            dsVersion={showUpdatedDesign ? "2.0" : "1.0"}
                          />
                        }
                        condition={_.size(setLabel) > 16}
                        type={"wrapperAsElement"}
                      >
                        <div className={classes.setLabel}>{setLabel}</div>
                      </ConditionalWrapper>
                      {showCriteriaDescriptorButton && (
                        <div
                          className={classes.criteriaDescriptorIcon}
                          style={criteriaDescriptorIconStyle}
                          onClick={() => onClickOfSetIcon(set)}
                        >
                          <InformationOutlined
                            size={infoIconSize}
                            variant="subtle"
                          />
                        </div>
                      )}
                    </div>
                  </div>
                );
              })
            : null}
        </div>
      </div>
    );
  }
);

CriteriaSetHeaderRow.displayName = "CriteriaSetHeaderRow";

const EvaluationRowsContainer = memo(
  ({
    criteriaSet,
    nodes,
    createPypElementRating,
    deletePypElementRating,
    rootNodeId,
    getStudentElementRatingValueOfCriteriaSet,
    checkCriteriaSetOfPypTypeInLevels,
    isComplete,
    totalLevels,
    depth,
    rootStyle,
    t,
    curriculumProgramType,
    subjectId,
    isMinimalDesign,
    updatePost,
    elementRatings,
    postAllStudentRatings,
    isJournalPostRating,
    parentId,
    studentId,
    updatePostRatingsCollectively,
    criteriaDescriptorState,
    setCriteriaDescriptorState,
    parentContainerRef,
    showCriteriaColumns,
    leftContainerStyle,
    customHeaderLabelStyle,
    criteriaSetHeaderLabelPreviewStyle,
    infoIconSize,
    sourceFrom,
    criteriaSetHeaderRowStyle,
    rowContainerStyle,
    shouldCloseOnValueChange,
    showDropdown,
    updateIsTextFocus,
    criteriaDescriptorIconStyle,
    subjectIds,
    userId,
    showUpdatedDesign,
    showUnorderedList,
    showRatingIfVisibleInViewPort,
    isNewGradingSetupEnabled,
    isGeneratingAIResponse,
    academicTermId,
    onAcceptAIEvaluation,
    learningCourseId,
    plannerElementType,
    plannerElementSetsByPlannerElementType,
    isCriteriaSetLoading,
    gradeScaleDepthLevels,
  }) => {
    const getRootNodeId = ({ type, rootNodeId, nodeId }) => {
      switch (type) {
        case ELEMENT_TYPE_UBD_ATL:
        case ELEMENT_TYPE_MYP_ATL:
        case ELEMENT_TYPE_DP_ATL:
          return rootNodeId || nodeId;
        default:
          return rootNodeId;
      }
    };
    return (
      <div className={classes.rowsContainer}>
        {_.map(nodes, node => {
          return (
            <EvaluationRowContainer
              t={t}
              criteriaSet={criteriaSet}
              node={node}
              getStudentElementRatingValueOfCriteriaSet={
                getStudentElementRatingValueOfCriteriaSet
              }
              rootStyle={rootStyle}
              totalLevels={totalLevels}
              depth={depth}
              key={node.id}
              isComplete={isComplete}
              rootNodeId={getRootNodeId({
                type: node.type,
                rootNodeId,
                nodeId: node.id,
              })}
              checkCriteriaSetOfPypTypeInLevels={
                checkCriteriaSetOfPypTypeInLevels
              }
              createPypElementRating={createPypElementRating}
              deletePypElementRating={deletePypElementRating}
              curriculumProgramType={curriculumProgramType}
              subjectId={subjectId}
              isMinimalDesign={isMinimalDesign}
              updatePost={updatePost}
              elementRatings={elementRatings}
              postAllStudentRatings={postAllStudentRatings}
              isJournalPostRating={isJournalPostRating}
              studentId={studentId}
              parentId={parentId}
              updatePostRatingsCollectively={updatePostRatingsCollectively}
              criteriaDescriptorState={criteriaDescriptorState}
              setCriteriaDescriptorState={setCriteriaDescriptorState}
              parentContainerRef={parentContainerRef}
              showCriteriaColumns={showCriteriaColumns}
              leftContainerStyle={leftContainerStyle}
              customHeaderLabelStyle={customHeaderLabelStyle}
              criteriaSetHeaderLabelPreviewStyle={
                criteriaSetHeaderLabelPreviewStyle
              }
              infoIconSize={infoIconSize}
              sourceFrom={sourceFrom}
              criteriaSetHeaderRowStyle={criteriaSetHeaderRowStyle}
              rowContainerStyle={rowContainerStyle}
              shouldCloseOnValueChange={shouldCloseOnValueChange}
              showDropdown={showDropdown}
              updateIsTextFocus={updateIsTextFocus}
              criteriaDescriptorIconStyle={criteriaDescriptorIconStyle}
              subjectIds={subjectIds}
              userId={userId}
              showUpdatedDesign={showUpdatedDesign}
              showUnorderedList={showUnorderedList}
              showRatingIfVisibleInViewPort={showRatingIfVisibleInViewPort}
              isNewGradingSetupEnabled={isNewGradingSetupEnabled}
              isGeneratingAIResponse={isGeneratingAIResponse}
              academicTermId={academicTermId}
              onAcceptAIEvaluation={onAcceptAIEvaluation}
              learningCourseId={learningCourseId}
              plannerElementType={plannerElementType}
              plannerElementSetsByPlannerElementType={
                plannerElementSetsByPlannerElementType
              }
              isCriteriaSetLoading={isCriteriaSetLoading}
              gradeScaleDepthLevels={gradeScaleDepthLevels}
            />
          );
        })}
      </div>
    );
  }
);

EvaluationRowsContainer.displayName = "EvaluationRowsContainer";

const EvaluationRowContainer = memo(
  ({
    criteriaSet,
    node,
    createPypElementRating,
    deletePypElementRating,
    rootNodeId,
    getStudentElementRatingValueOfCriteriaSet,
    checkCriteriaSetOfPypTypeInLevels,
    isComplete,
    depth,
    rootStyle,
    totalLevels,
    t,
    curriculumProgramType,
    subjectId,
    isMinimalDesign,
    updatePost,
    elementRatings,
    postAllStudentRatings,
    isJournalPostRating,
    studentId,
    parentId,
    updatePostRatingsCollectively,
    criteriaDescriptorState,
    setCriteriaDescriptorState,
    parentContainerRef,
    showCriteriaColumns,
    leftContainerStyle,
    customHeaderLabelStyle,
    criteriaSetHeaderLabelPreviewStyle,
    infoIconSize,
    sourceFrom,
    criteriaSetHeaderRowStyle,
    rowContainerStyle,
    shouldCloseOnValueChange,
    showDropdown,
    updateIsTextFocus,
    criteriaDescriptorIconStyle,
    subjectIds,
    userId,
    showUpdatedDesign,
    showUnorderedList,
    showRatingIfVisibleInViewPort,
    showCriteriaDescriptorButton,
    isNewGradingSetupEnabled,
    isGeneratingAIResponse,
    academicTermId,
    onAcceptAIEvaluation,
    learningCourseId,
    plannerElementType,
    plannerElementSetsByPlannerElementType,
    isCriteriaSetLoading,
    gradeScaleDepthLevels,
  }) => {
    const [
      criteriaSetContainerRef,
      setCriteriaSetContainerRef,
    ] = useCallbackRef();

    const [
      isCriteriaSetContainerVisible,
      setIsCriteriaSetContainerVisible,
    ] = useState(!showRatingIfVisibleInViewPort);

    useEffect(() => {
      if (!showRatingIfVisibleInViewPort) {
        return;
      }

      const target = criteriaSetContainerRef.current;

      if (!target) {
        return;
      }

      // handler for when target is in viewport
      const inHandler = (entry, unobserve) => {
        if (!isCriteriaSetContainerVisible) {
          setIsCriteriaSetContainerVisible(true);
        } else {
          // stop observing this row element.
          // because now it's already visible to user
          unobserve();
        }
      };

      // the returned function, when called, stops tracking the target element in the given viewport
      const unobserveFn = observeElementInViewport(target, inHandler, _.noop, {
        viewport: null,
      });

      return () => {
        // remove intersection observer from DOM node
        unobserveFn();
        criteriaSetContainerRef.current = null;
      };
    }, []);
    const rootLabelIndex =
      _.indexOf(levelsLabelStyleMapping, rootStyle) +
      (isNewGradingSetupEnabled ? 1 : 0);
    const labelStyle = levelsLabelStyleMapping[depth + rootLabelIndex - 1];
    const minLevelId = _.get(node, "levels[0].id", "");
    const rowContainerClass = classNames({
      [classes.rowContainer]: true,
      [classes.rowContainerPreview]: isMinimalDesign,
      [classes.rowContainerLevelPreview]:
        isMinimalDesign && node.levelId !== minLevelId,
    });
    const nodeLabelClass = classNames({
      [classes[labelStyle]]: !showUnorderedList,
      [classes[`${labelStyle}Preview`]]: isMinimalDesign && !showUnorderedList,
      [classes[`${labelStyle}ClassRoom`]]:
        isMinimalDesign &&
        _.includes(["CLASSROOM", "GRADEBOOK"], sourceFrom) &&
        !showUnorderedList,
      ["text-body"]: showUnorderedList,
      [classes.listTypeLabelWithDisc]: depth == 2 && showUnorderedList,
      [classes.listTypeLabelWithCircle]: depth == 3 && showUnorderedList,
      [classes.listTypeLabelWithSquare]: depth > 3 && showUnorderedList,
    });

    const leftContainerClass = classNames({
      [classes.leftContainer]: true,
      [classes.leftContainerPreview]: isMinimalDesign,
      [classes.leftContainerWithDummySet]: !isCriteriaSetContainerVisible,
    });
    const indentation = isMinimalDesign
      ? (depth == 1 && showUnorderedList ? depth - 1 : depth) *
          PARENT_CHILD_INDENTATION_V2 -
        4
      : (depth - 1) * PARENT_CHILD_INDENTATION;

    return (
      <div className={classes.parentContainer}>
        <div className={rowContainerClass} style={rowContainerStyle}>
          <div
            className={leftContainerClass}
            style={{
              paddingLeft: indentation,
              width: `${Math.max(40, 80 - 10 * criteriaSet.length)}%`,
              ...leftContainerStyle,
            }}
          >
            <div className={nodeLabelClass}>
              {getSubjectStandardWithCode({
                label: _.get(node, "label", ""),
                code: _.get(node, "code", ""),
              })}
            </div>
          </div>
          {showCriteriaColumns ? (
            <CriteriaSetContainer
              t={t}
              isComplete={isComplete}
              criteriaSet={criteriaSet}
              checkCriteriaSetOfPypTypeInLevels={params =>
                checkCriteriaSetOfPypTypeInLevels({
                  ...params,
                  levelId: node.levelId,
                  parentId: rootNodeId,
                  type: node.ibPlannerElementType,
                })
              }
              createPypElementRating={params => {
                const { set, ...restParams } = params || {};

                createPypElementRating({
                  ...(restParams || {}),
                  id: node.id,
                  type: node.ibPlannerElementType,
                  ...getCreateRatingParams({
                    rootNodeId,
                    curriculumProgramType,
                    type: node.ibPlannerElementType,
                    subjectId,
                    set,
                    isNewGradingSetupEnabled,
                  }),
                  sourceFrom,
                });
              }}
              deletePypElementRating={params =>
                deletePypElementRating({
                  ...params,
                  id: node.id,
                  type: node.ibPlannerElementType,
                })
              }
              getStudentElementRatingValueOfCriteriaSet={params =>
                getStudentElementRatingValueOfCriteriaSet({
                  ...params,
                  id: node.id,
                  type: node.ibPlannerElementType,
                })
              }
              isMinimalDesign={isMinimalDesign}
              updatePost={updatePost}
              node={node}
              elementRatings={elementRatings}
              postAllStudentRatings={postAllStudentRatings}
              isJournalPostRating={isJournalPostRating}
              studentId={studentId}
              parentId={parentId}
              updatePostRatingsCollectively={updatePostRatingsCollectively}
              criteriaDescriptorState={criteriaDescriptorState}
              setCriteriaDescriptorState={setCriteriaDescriptorState}
              parentContainerRef={parentContainerRef}
              subjectId={subjectId}
              rootNodeId={rootNodeId}
              curriculumProgramType={curriculumProgramType}
              infoIconSize={infoIconSize}
              sourceFrom={sourceFrom}
              shouldCloseOnValueChange={shouldCloseOnValueChange}
              showDropdown={showDropdown}
              updateIsTextFocus={updateIsTextFocus}
              criteriaDescriptorIconStyle={criteriaDescriptorIconStyle}
              subjectIds={subjectIds}
              userId={userId}
              showUpdatedDesign={showUpdatedDesign}
              setCriteriaSetContainerRef={setCriteriaSetContainerRef}
              isCriteriaSetContainerVisible={isCriteriaSetContainerVisible}
              criteriaSetHeaderLabelPreviewStyle={
                criteriaSetHeaderLabelPreviewStyle
              }
              showCriteriaDescriptorButton={showCriteriaDescriptorButton}
              isNewGradingSetupEnabled={isNewGradingSetupEnabled}
              isGeneratingAIResponse={isGeneratingAIResponse}
              academicTermId={academicTermId}
              onAcceptAIEvaluation={onAcceptAIEvaluation}
              learningCourseId={learningCourseId}
              plannerElementType={plannerElementType}
              plannerElementSetsByPlannerElementType={
                plannerElementSetsByPlannerElementType
              }
              isCriteriaSetLoading={isCriteriaSetLoading}
              gradeScaleDepthLevels={gradeScaleDepthLevels}
              depth={depth}
            />
          ) : null}
        </div>
        {_.get(node.children, "length", 0) > 0 && (
          <EvaluationRowsContainer
            t={t}
            depth={depth + 1}
            isComplete={isComplete}
            criteriaSet={criteriaSet}
            rootNodeId={rootNodeId}
            nodes={node.children}
            totalLevels={totalLevels}
            createPypElementRating={createPypElementRating}
            deletePypElementRating={deletePypElementRating}
            checkCriteriaSetOfPypTypeInLevels={
              checkCriteriaSetOfPypTypeInLevels
            }
            getStudentElementRatingValueOfCriteriaSet={
              getStudentElementRatingValueOfCriteriaSet
            }
            rootStyle={rootStyle}
            curriculumProgramType={curriculumProgramType}
            subjectId={subjectId}
            isMinimalDesign={isMinimalDesign}
            updatePost={updatePost}
            elementRatings={elementRatings}
            postAllStudentRatings={postAllStudentRatings}
            isJournalPostRating={isJournalPostRating}
            studentId={studentId}
            parentId={parentId}
            updatePostRatingsCollectively={updatePostRatingsCollectively}
            criteriaDescriptorState={criteriaDescriptorState}
            setCriteriaDescriptorState={setCriteriaDescriptorState}
            parentContainerRef={parentContainerRef}
            showCriteriaColumns={showCriteriaColumns}
            leftContainerStyle={leftContainerStyle}
            customHeaderLabelStyle={customHeaderLabelStyle}
            criteriaSetHeaderLabelPreviewStyle={
              criteriaSetHeaderLabelPreviewStyle
            }
            infoIconSize={infoIconSize}
            sourceFrom={sourceFrom}
            criteriaSetHeaderRowStyle={criteriaSetHeaderRowStyle}
            rowContainerStyle={rowContainerStyle}
            shouldCloseOnValueChange={shouldCloseOnValueChange}
            showDropdown={showDropdown}
            updateIsTextFocus={updateIsTextFocus}
            criteriaDescriptorIconStyle={criteriaDescriptorIconStyle}
            subjectIds={subjectIds}
            userId={userId}
            showUpdatedDesign={showUpdatedDesign}
            showUnorderedList={showUnorderedList}
            showRatingIfVisibleInViewPort={showRatingIfVisibleInViewPort}
            isNewGradingSetupEnabled={isNewGradingSetupEnabled}
            isGeneratingAIResponse={isGeneratingAIResponse}
            academicTermId={academicTermId}
            onAcceptAIEvaluation={onAcceptAIEvaluation}
            learningCourseId={learningCourseId}
            plannerElementSetsByPlannerElementType={
              plannerElementSetsByPlannerElementType
            }
            plannerElementType={plannerElementType}
            isCriteriaSetLoading={isCriteriaSetLoading}
            gradeScaleDepthLevels={gradeScaleDepthLevels}
          />
        )}
      </div>
    );
  }
);

EvaluationRowContainer.displayName = "EvaluationRowContainer";

const MultiLevelEvaluationBox = memo(
  ({
    type,
    nodes,
    getCriteriaSetOfPypType,
    createPypElementRating,
    deletePypElementRating,
    getStudentElementRatingValueOfCriteriaSet,
    checkCriteriaSetOfPypTypeInLevels,
    isComplete,
    rootStyle,
    label,
    t,
    curriculumProgramType,
    subjectId,
    isMinimalDesign,
    levelType,
    updatePost,
    elementRatings,
    postAllStudentRatings,
    isJournalPostRating,
    studentId,
    parentId,
    updatePostRatingsCollectively,
    showCriteriaDescriptorButton,
    criteriaDescriptorState,
    setCriteriaDescriptorState,
    parentContainerRef,
    showCriteriaColumns,
    showNodesIfCriteriaEmpty,
    leftContainerStyle,
    customHeaderLabelStyle,
    criteriaSetHeaderLabelPreviewStyle,
    infoIconSize,
    sourceFrom,
    evaluationBodyStyle,
    criteriaSetHeaderRowStyle,
    rowContainerStyle,
    showCriteriaSetHeader,
    rootContainerStyle,
    shouldCloseOnValueChange,
    evaluationContainerStyle,
    showDropdown,
    updateIsTextFocus,
    criteriaDescriptorIconStyle,
    subjectIds,
    userId,
    showUpdatedDesign,
    headerRowLeftContainerStyle,
    showUnorderedList,
    showRatingIfVisibleInViewPort,
    isNewGradingSetupEnabled,
    learningCourseStandards,
    isGeneratingAIResponse,
    academicTermId,
    onAcceptAIEvaluation,
    standards,
    learningCourseId,
    isAiEvaluationEnabled,
    isEvaluationModalView,
    plannerElementType,
    plannerElementSetsByPlannerElementType,
    gradeScaleByPlannerElementType,
    isCriteriaSetLoading,
    gradeScaleDepthLevels,
  }) => {
    const evaluationBodyClass = classNames({
      [classes.evaluationBody]: true,
      [classes.evaluationBodyBorderRadius]: !isEvaluationModalView,
      [classes.evaluationBodyMultiLevelPreview]: isMinimalDesign,
    });
    const rootContainerClass = classNames({
      [classes.rootContainer]: true,
      [classes.rootContainerPreview]: isMinimalDesign,
    });
    const renderNodes = () => {
      let isCriteriaEmpty = true;
      const evaluationBody = (
        <div className={evaluationBodyClass} style={evaluationBodyStyle}>
          {_.map(nodes, (node, index) => {
            const rootNodeId = node.id;

            let criteriaSet = [];
            if (isNewGradingSetupEnabled) {
              criteriaSet = getIsSubjectStandard({ type })
                ? getGradeScalesByRootNodeIdMemoized(standards, node)
                : _.get(gradeScaleByPlannerElementType, plannerElementType, []);
            } else {
              criteriaSet = filteredCriteriaSetsMemoized({
                type: node.ibPlannerElementType,
                levelId: node.levelId,
                rootNodeId,
                node: node,
                getCriteriaSetOfPypType,
                criteriaType: "CUSTOM",
              });
            }

            const hideCriteriaSetHeader = isMinimalDesign && index !== 0;
            isCriteriaEmpty = !_.isEmpty(criteriaSet) ? false : isCriteriaEmpty;
            return (
              <div
                className={rootContainerClass}
                key={node.id}
                style={rootContainerStyle}
              >
                {!hideCriteriaSetHeader || showCriteriaSetHeader ? (
                  <CriteriaSetHeaderRow
                    criteriaSet={criteriaSet}
                    headerLabel={label}
                    isMinimalDesign={isMinimalDesign}
                    levelType={levelType}
                    showCriteriaDescriptorButton={showCriteriaDescriptorButton}
                    setCriteriaDescriptorState={setCriteriaDescriptorState}
                    isComplete={isComplete}
                    leftContainerStyle={leftContainerStyle}
                    customHeaderLabelStyle={customHeaderLabelStyle}
                    criteriaSetHeaderLabelPreviewStyle={
                      criteriaSetHeaderLabelPreviewStyle
                    }
                    infoIconSize={infoIconSize}
                    sourceFrom={sourceFrom}
                    criteriaSetHeaderRowStyle={criteriaSetHeaderRowStyle}
                    rowContainerStyle={rowContainerStyle}
                    criteriaDescriptorIconStyle={criteriaDescriptorIconStyle}
                    showUpdatedDesign={showUpdatedDesign}
                    showCriteriaColumns={
                      isNewGradingSetupEnabled && getIsSubjectStandard({ type })
                        ? false
                        : showCriteriaColumns
                    }
                    headerRowLeftContainerStyle={headerRowLeftContainerStyle}
                    isNewGradingSetupEnabled={isNewGradingSetupEnabled}
                    isCriteriaSetLoading={isCriteriaSetLoading}
                  />
                ) : null}
                <EvaluationRowContainer
                  t={t}
                  criteriaSet={criteriaSet}
                  node={node}
                  getStudentElementRatingValueOfCriteriaSet={
                    getStudentElementRatingValueOfCriteriaSet
                  }
                  rootStyle={rootStyle}
                  totalLevels={_.get(node, "levels.length", 1)}
                  depth={1}
                  isComplete={isComplete}
                  rootNodeId={rootNodeId}
                  checkCriteriaSetOfPypTypeInLevels={
                    checkCriteriaSetOfPypTypeInLevels
                  }
                  createPypElementRating={createPypElementRating}
                  deletePypElementRating={deletePypElementRating}
                  curriculumProgramType={curriculumProgramType}
                  subjectId={subjectId}
                  isMinimalDesign={isMinimalDesign}
                  updatePost={updatePost}
                  elementRatings={elementRatings}
                  postAllStudentRatings={postAllStudentRatings}
                  isJournalPostRating={isJournalPostRating}
                  studentId={studentId}
                  parentId={parentId}
                  updatePostRatingsCollectively={updatePostRatingsCollectively}
                  criteriaDescriptorState={criteriaDescriptorState}
                  setCriteriaDescriptorState={setCriteriaDescriptorState}
                  parentContainerRef={parentContainerRef}
                  showCriteriaColumns={showCriteriaColumns}
                  leftContainerStyle={leftContainerStyle}
                  customHeaderLabelStyle={customHeaderLabelStyle}
                  criteriaSetHeaderLabelPreviewStyle={
                    criteriaSetHeaderLabelPreviewStyle
                  }
                  infoIconSize={infoIconSize}
                  sourceFrom={sourceFrom}
                  criteriaSetHeaderRowStyle={criteriaSetHeaderRowStyle}
                  rowContainerStyle={rowContainerStyle}
                  shouldCloseOnValueChange={shouldCloseOnValueChange}
                  showDropdown={showDropdown}
                  updateIsTextFocus={updateIsTextFocus}
                  criteriaDescriptorIconStyle={criteriaDescriptorIconStyle}
                  subjectIds={subjectIds}
                  userId={userId}
                  showUpdatedDesign={showUpdatedDesign}
                  showUnorderedList={showUnorderedList}
                  showRatingIfVisibleInViewPort={showRatingIfVisibleInViewPort}
                  showCriteriaDescriptorButton={
                    showCriteriaDescriptorButton &&
                    !getIsNewGradingSetupEnabled()
                  }
                  isNewGradingSetupEnabled={isNewGradingSetupEnabled}
                  isGeneratingAIResponse={isGeneratingAIResponse}
                  academicTermId={academicTermId}
                  onAcceptAIEvaluation={onAcceptAIEvaluation}
                  learningCourseId={learningCourseId}
                  plannerElementType={plannerElementType}
                  plannerElementSetsByPlannerElementType={
                    plannerElementSetsByPlannerElementType
                  }
                  isCriteriaSetLoading={isCriteriaSetLoading}
                  gradeScaleDepthLevels={gradeScaleDepthLevels}
                />
              </div>
            );
          })}
        </div>
      );

      return { evaluationBody, isCriteriaEmpty };
    };

    const { evaluationBody, isCriteriaEmpty } = renderNodes();
    return (
      <div
        className={classes.evaluationContainer}
        style={{
          marginBottom: isAiEvaluationEnabled ? "16px" : "20px",
          ...evaluationContainerStyle,
        }}
      >
        {!isMinimalDesign && (
          <div className={classes.evaluationLabel}>{label}</div>
        )}
        {_.get(nodes, "length", 0) > 0 ? (
          showNodesIfCriteriaEmpty || !isCriteriaEmpty ? (
            evaluationBody
          ) : !isComplete ? (
            <div className={classes.emptyCriteriaView}>
              <div className={classes.noEvaluationHeaderLabel}>{label}</div>
              <div className={classes.noEvaluationText}>
                {t("journal:no_evaluation_criteria")}
              </div>
            </div>
          ) : null
        ) : (
          <EmptyField
            title={t("assessmentEvaluation:not_selected_le_label", {
              label: label.toLowerCase(),
            })}
          />
        )}
      </div>
    );
  }
);

MultiLevelEvaluationBox.displayName = "MultiLevelEvaluationBox";

const SingleLevelEvaluationBox = memo(
  ({
    type,
    plannerElementType,
    nodes,
    getCriteriaSetOfPypType,
    getStudentElementRatingValueOfCriteriaSet,
    checkCriteriaSetOfPypTypeInLevels,
    createPypElementRating,
    deletePypElementRating,
    isComplete,
    rootStyle,
    label,
    t,
    curriculumProgramType,
    subjectId,
    isMinimalDesign,
    levelType,
    updatePost,
    elementRatings,
    postAllStudentRatings,
    isJournalPostRating,
    parentId,
    studentId,
    updatePostRatingsCollectively,
    showCriteriaDescriptorButton,
    criteriaDescriptorState,
    setCriteriaDescriptorState,
    parentContainerRef,
    showCriteriaColumns,
    showNodesIfCriteriaEmpty,
    leftContainerStyle,
    customHeaderLabelStyle,
    criteriaSetHeaderLabelPreviewStyle,
    infoIconSize,
    sourceFrom,
    evaluationBodyStyle,
    criteriaSetHeaderRowStyle,
    rowContainerStyle,
    shouldCloseOnValueChange,
    evaluationContainerStyle,
    showDropdown,
    updateIsTextFocus,
    criteriaDescriptorIconStyle,
    subjectIds,
    userId,
    showUpdatedDesign,
    headerRowLeftContainerStyle,
    showUnorderedList,
    showRatingIfVisibleInViewPort,
    isGeneratingAIResponse,
    onAcceptAIEvaluation,
    academicTermId,
    isAiEvaluationEnabled,
    isEvaluationModalView,
    isNewGradingSetupEnabled,
    learningCourseId,
    gradeScaleByPlannerElementType,
    plannerElementSetsByPlannerElementType,
    isCriteriaSetLoading,
    gradeScaleDepthLevels,
  }) => {
    const criteriaSet = isNewGradingSetupEnabled
      ? _.get(gradeScaleByPlannerElementType, plannerElementType, [])
      : _.reduce(
          nodes,
          (result, node) => {
            result = _.unionBy(
              result,
              filteredCriteriaSetsMemoized({
                criteriaType: "CUSTOM",
                type: node.ibPlannerElementType,
                levelId: node.levelId,
                rootNodeId: getRootNodeId({
                  curriculumProgramType,
                  rootNodeId: node.id,
                  ibPYPElementType: node.type,
                }),
                node: node,
                getCriteriaSetOfPypType,
              }),
              "id"
            );
            return result;
          },
          []
        );

    const evaluationBodyClass = classNames({
      [classes.evaluationBody]: true,
      [classes.evaluationBodyBorderRadius]: !isEvaluationModalView,
      [classes.evaluationBodyPreview]: isMinimalDesign,
    });
    return (
      _.get(nodes, "length", 0) > 0 && (
        <div
          className={classes.evaluationContainer}
          style={{
            marginBottom: isAiEvaluationEnabled ? "16px" : "24px",
            ...evaluationContainerStyle,
          }}
        >
          {!isMinimalDesign && (
            <div className={classes.evaluationLabel}>{label}</div>
          )}
          {showNodesIfCriteriaEmpty || !_.isEmpty(criteriaSet) ? (
            _.get(nodes, "length", 0) > 0 ? (
              <div className={evaluationBodyClass} style={evaluationBodyStyle}>
                <CriteriaSetHeaderRow
                  criteriaSet={criteriaSet}
                  headerLabel={label}
                  isMinimalDesign={isMinimalDesign}
                  levelType={levelType}
                  showCriteriaDescriptorButton={showCriteriaDescriptorButton}
                  setCriteriaDescriptorState={setCriteriaDescriptorState}
                  showCriteriaColumns={showCriteriaColumns}
                  isComplete={isComplete}
                  leftContainerStyle={leftContainerStyle}
                  customHeaderLabelStyle={customHeaderLabelStyle}
                  criteriaSetHeaderLabelPreviewStyle={
                    criteriaSetHeaderLabelPreviewStyle
                  }
                  infoIconSize={infoIconSize}
                  sourceFrom={sourceFrom}
                  criteriaSetHeaderRowStyle={criteriaSetHeaderRowStyle}
                  rowContainerStyle={rowContainerStyle}
                  criteriaDescriptorIconStyle={criteriaDescriptorIconStyle}
                  showUpdatedDesign={showUpdatedDesign}
                  headerRowLeftContainerStyle={headerRowLeftContainerStyle}
                  isNewGradingSetupEnabled={isNewGradingSetupEnabled}
                  isCriteriaSetLoading={isCriteriaSetLoading}
                />
                <EvaluationRowsContainer
                  t={t}
                  depth={1}
                  totalLevels={1}
                  rootStyle={rootStyle}
                  type={type}
                  isComplete={isComplete}
                  criteriaSet={criteriaSet}
                  nodes={nodes}
                  getStudentElementRatingValueOfCriteriaSet={
                    getStudentElementRatingValueOfCriteriaSet
                  }
                  createPypElementRating={createPypElementRating}
                  deletePypElementRating={deletePypElementRating}
                  checkCriteriaSetOfPypTypeInLevels={
                    checkCriteriaSetOfPypTypeInLevels
                  }
                  curriculumProgramType={curriculumProgramType}
                  subjectId={subjectId}
                  isMinimalDesign={isMinimalDesign}
                  updatePost={updatePost}
                  elementRatings={elementRatings}
                  postAllStudentRatings={postAllStudentRatings}
                  isJournalPostRating={isJournalPostRating}
                  studentId={studentId}
                  parentId={parentId}
                  updatePostRatingsCollectively={updatePostRatingsCollectively}
                  criteriaDescriptorState={criteriaDescriptorState}
                  setCriteriaDescriptorState={setCriteriaDescriptorState}
                  parentContainerRef={parentContainerRef}
                  showCriteriaColumns={showCriteriaColumns}
                  leftContainerStyle={leftContainerStyle}
                  customHeaderLabelStyle={customHeaderLabelStyle}
                  criteriaSetHeaderLabelPreviewStyle={
                    criteriaSetHeaderLabelPreviewStyle
                  }
                  infoIconSize={infoIconSize}
                  sourceFrom={sourceFrom}
                  criteriaSetHeaderRowStyle={criteriaSetHeaderRowStyle}
                  rowContainerStyle={rowContainerStyle}
                  shouldCloseOnValueChange={shouldCloseOnValueChange}
                  showDropdown={showDropdown}
                  updateIsTextFocus={updateIsTextFocus}
                  criteriaDescriptorIconStyle={criteriaDescriptorIconStyle}
                  subjectIds={subjectIds}
                  userId={userId}
                  showUpdatedDesign={showUpdatedDesign}
                  showUnorderedList={showUnorderedList}
                  showRatingIfVisibleInViewPort={showRatingIfVisibleInViewPort}
                  isGeneratingAIResponse={isGeneratingAIResponse}
                  onAcceptAIEvaluation={onAcceptAIEvaluation}
                  academicTermId={academicTermId}
                  isNewGradingSetupEnabled={isNewGradingSetupEnabled}
                  plannerElementType={plannerElementType}
                  plannerElementSetsByPlannerElementType={
                    plannerElementSetsByPlannerElementType
                  }
                  isCriteriaSetLoading={isCriteriaSetLoading}
                  gradeScaleDepthLevels={gradeScaleDepthLevels}
                  {...(getIsRatingSubjectOrCourseWise()
                    ? { learningCourseId }
                    : null)}
                />
              </div>
            ) : (
              <EmptyField
                title={t("assessmentEvaluation:not_selected_le_label", {
                  label: label.toLowerCase(),
                })}
              />
            )
          ) : !isComplete ? (
            <div className={classes.emptyCriteriaView}>
              <div className={classes.noEvaluationHeaderLabel}>{label}</div>
              <div className={classes.noEvaluationText}>
                {t("journal:no_evaluation_criteria")}
              </div>
            </div>
          ) : null}
        </div>
      )
    );
  }
);

SingleLevelEvaluationBox.displayName = "SingleLevelEvaluationBox";

const DynamicLevelEvaluationBox = memo(props => {
  return props.levelType == "single" ? (
    <SingleLevelEvaluationBox {...props} />
  ) : (
    <MultiLevelEvaluationBox {...props} />
  );
});

DynamicLevelEvaluationBox.displayName = "DynamicLevelEvaluationBox";
class PypEvaluationV2 extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      criteriaDescriptorState: {
        showDescriptiorModal: false,
        selectedCriteriaSet: [],
        showRatingDescriptorModal: false,
      },
    };
    this.parentContainerRef = React.createRef();
  }

  getCriteriaSetOfPypType = params => {
    const { grades, getCriteriaSetOfPypType } = this.props;
    return getCriteriaSetOfPypType({ ...params, grades });
  };

  setCriteriaDescriptorState = ({
    showDescriptiorModal,
    selectedCriteriaSet,
    showRatingDescriptorModal = false,
  }) => {
    this.setState({
      criteriaDescriptorState: {
        showDescriptiorModal,
        selectedCriteriaSet,
        showRatingDescriptorModal,
      },
    });
  };

  closeCriteriaDescriptorModal = () => {
    this.setCriteriaDescriptorState({
      showDescriptiorModal: false,
      showRatingDescriptorModal: false,
      selectedCriteriaSet: {},
    });
  };

  updateIsTextFocus = isTextFocus => {
    const { updateEvaluationData } = this.props;
    updateEvaluationData({ isTextFocus });
  };

  render() {
    const {
      pypElementsData,
      parentId,
      parentType,
      studentDetails,
      elementRatings,
      createIbPypElementRating,
      deletePypElementRating,
      checkCriteriaSetOfPypTypeInLevels,
      evaluateIBPYPElements,
      isComplete,
      toggleStudentPypEvaluateStatus,
      isEvaluatePypElement,
      showToggleStudentPypEvaluateStatus,
      isEvaluated,
      t,
      isArchivedClass,
      subjectId,
      curriculumProgramType,
      isMinimalDesign,
      updatePost,
      isJournalPostRating,
      postAllStudentRatings,
      updatePostRatingsCollectively,
      showCriteriaDescriptorButton,
      showCriteriaColumns = true,
      showNodesIfCriteriaEmpty = true,
      leftContainerStyle = {},
      containerStyle = {},
      customHeaderLabelStyle = {},
      criteriaSetHeaderLabelPreviewStyle = {},
      infoIconSize = "xx-small",
      sourceFrom = null,
      evaluationBodyStyle = {},
      criteriaSetHeaderRowStyle = {},
      rowContainerStyle = {},
      showCriteriaSetHeader = false,
      rootContainerStyle = {},
      shouldCloseOnValueChange = false,
      evaluationContainerStyle = {},
      showDropdown = false,
      criteriaDescriptorIconStyle = {},
      subjectIds,
      academicTermId = null,
      ibPYPElementRatingsLocal,
      setIBPYPElementRatingsLocal,
      isAutoSaveDisabled = false,
      userId,
      showUpdatedDesign,
      headerRowLeftContainerStyle = {},
      showUnorderedList,
      ibPYPElementRatings,
      isAiEvaluationEnabled,
      showRatingIfVisibleInViewPort,
      isGeneratingAIResponse,
      onAcceptAIEvaluation,
      learningCourseId,
      elementRemarks,
      isEvaluationModalView,
      gradeScaleByPlannerElementType,
      plannerElementSetsByPlannerElementType,
      isLearningCourseStandardsLoading = false,
      isCurriculumStandardsLoading = false,
      isPypPlannerElementNodesLoading = false,
      isPlannerElementNodesLoading = false,
      isDataSetQueryLoading = false,
      curriculumProgramId,
    } = this.props;
    const shouldAttachTermIdWithRating = ACLStore.can(
      "FeatureFlag:AttachTermIdWithRating"
    );

    const isNewGradingSetupEnabled = getIsNewGradingSetupEnabled();

    const gradeScaleDepthLevels = isNewGradingSetupEnabled
      ? getSettingValue({
          name: "GradeScaleDatasetDepthLevels",
          currentCurriculumProgramId: curriculumProgramId,
        }) ?? EMPTY_OBJECT
      : EMPTY_OBJECT;

    // Determine actual loading state - only count queries that should run
    const isCriteriaSetLoading =
      isNewGradingSetupEnabled &&
      (isLearningCourseStandardsLoading ||
        isCurriculumStandardsLoading ||
        isPypPlannerElementNodesLoading ||
        isPlannerElementNodesLoading ||
        isDataSetQueryLoading);

    const { criteriaDescriptorState = {} } = this.state;
    const showDescriptiorModal = _.get(
      criteriaDescriptorState,
      "showDescriptiorModal",
      false
    );

    const isArchived = _.get(studentDetails, "isArchived");
    const isDisabled = isArchivedClass || isArchived;

    const pypRootLevelStyleMapping = getPypRootLevelStyleMapping({
      sourceFrom,
    });

    /**
     * Updates element list based on learning course standards
     * Preserves original properties from elementList when matching by ID
     */
    const processElementList = ({ elementList }) => {
      const { standards, assessmentFields } = this.props;

      // Early return checks
      if (
        !isNewGradingSetupEnabled ||
        _.isEmpty(standards) ||
        _.isEmpty(elementList)
      ) {
        return elementList;
      }

      const elementType = _.get(elementList, "[0].ibPlannerElementType");
      if (!elementType) {
        return elementList;
      }

      const assessmentField = _.find(
        assessmentFields,
        field => pypElementMapping[field.uid] === elementType
      );
      if (!assessmentField) {
        return elementList;
      }

      // elementList is nested structure with ordered nodes based on display sequence
      // So extracting values from there instead of assessmentField.value
      // Directly reading from assessmentField.value can lead to unordered values
      const resolvedNodes = getFlattenedNodes({
        nodes: elementList,
      });
      const resolvedValues = _.get(assessmentField, "value", []);
      const selectedValues = _.map(
        _.filter(resolvedNodes, node => _.includes(resolvedValues, node.id)),
        "id"
      );

      if (_.isEmpty(selectedValues)) {
        return elementList;
      }

      // Create lookup maps for efficient access
      const standardLabelsMap = createStandardLabelsMap(assessmentField);
      const standardSetIds = _.compact(_.map(standards, "standardSet.id")); // Added _.compact for safety
      const selectedStandardSetIds = _.intersection(
        selectedValues,
        standardSetIds
      );

      // Create element map using a more efficient approach
      const elementMap = {};
      const buildElementMap = elements => {
        if (_.isEmpty(elements)) return;

        for (const element of elements) {
          if (element && element.id) {
            elementMap[element.id] = element;
          }
          if (!_.isEmpty(element?.children)) {
            for (const child of element.children) {
              if (child && child.id) {
                elementMap[child.id] = child;
              }
            }
            buildElementMap(element.children);
          }
        }
      };
      buildElementMap(elementList);

      // Build standards lookup data structures
      const standardsById = {};
      const standardsBySetId = {};
      const childToParentMap = {};

      // Process standards once to build lookup structures
      _.forEach(standards, ({ standardSet }) => {
        if (_.isNil(standardSet) || _.isNil(_.get(standardSet, "id"))) return;

        const setId = standardSet.id;
        standardsBySetId[setId] = {
          standardSet,
          standards: [],
        };
        const standardSetWrapper = _.get(standardSet, "standardSetWrapper", {});
        const edges =
          _.get(standardSetWrapper, "publishedStandards.edges") ||
          _.get(standardSetWrapper, "publishedBenchmarks.edges") ||
          [];
        const standardsNode = _.compact(_.map(edges, "node"));

        _.forEach(standardsNode, standard => {
          if (!standard || !standard.id) return;

          standardsById[standard.id] = { standard, standardSet };

          // Track parent-child relationships
          if (standard.parent && standard.parent !== standard.id) {
            childToParentMap[standard.id] = standard.parent;
          }
        });
      });

      // Pre-calculate which standards are children of selected standards
      const isChildOfSelectedStandard = {};
      _.forEach(selectedValues, id => {
        const parentId = childToParentMap[id];
        if (parentId && _.includes(selectedValues, parentId)) {
          isChildOfSelectedStandard[id] = true;
        }
      });

      // Populate standardsBySetId with selected standards
      _.forEach(selectedStandardSetIds, setId => {
        const standardSet = _.find(
          standards,
          data => _.get(data, "standardSet.id") === setId
        );

        if (standardSet && standardSet.standardSet) {
          const filteredStandards = _.filter(
            _.get(standardSet, "standards", []),
            standard => _.includes(selectedValues, _.get(standard, "id"))
          );

          if (!_.isEmpty(filteredStandards)) {
            standardsBySetId[setId].standards = filteredStandards;
          }
        }
      });

      // Process individually selected standards that aren't in selected sets
      const nonSetValues = _.difference(selectedValues, standardSetIds);
      _.forEach(nonSetValues, id => {
        const standardData = standardsById[id];
        if (!standardData) return;

        const { standard, standardSet } = standardData;
        if (!standardSet || !standardSet.id) return;

        const setId = standardSet.id;

        if (!standardsBySetId[setId]) {
          standardsBySetId[setId] = {
            standardSet,
            standards: [],
          };
        }

        if (!_.some(standardsBySetId[setId].standards, { id })) {
          standardsBySetId[setId].standards.push(standard);
        }
      });

      /**
       * Process a standard element and its children recursively
       */
      const processStandardElement = (
        standard,
        originalElement,
        index,
        standardSetId,
        allStandards
      ) => {
        if (!standard || !standard.id) return null; // Added safety check

        // Get label with appropriate fallbacks
        const label =
          standardLabelsMap[standard.id] ||
          (originalElement && originalElement.label) ||
          standard.title;

        // Get isGradedStandard with proper fallbacks
        const isGradedStandard = _.has(originalElement, "isGradedStandard")
          ? _.get(originalElement, "isGradedStandard")
          : _.get(
              standard,
              "standardsWrapper.properties.isGradedStandard",
              true
            );

        // Find and process child standards
        const childStandards = _.filter(
          allStandards,
          childStandard =>
            childStandard &&
            childStandard.id &&
            childStandard.parent === standard.id &&
            _.includes(selectedValues, childStandard.id)
        );

        const standardChildren = _.compact(
          _.map(childStandards, (childStandard, childIndex) => {
            const childOriginalElement = elementMap[childStandard.id];
            return processStandardElement(
              childStandard,
              childOriginalElement,
              childIndex,
              standardSetId,
              allStandards
            );
          })
        );

        // Process original element's children if needed
        let finalChildren;
        if (
          _.isEmpty(standardChildren) &&
          !_.isEmpty(_.get(originalElement, "children"))
        ) {
          const processedChildren = _.compact(
            _.map(originalElement.children, child => {
              if (!child) return null;

              const childIsGradedStandard = _.has(child, "isGradedStandard")
                ? _.get(child, "isGradedStandard")
                : isGradedStandard;

              // Process nested children recursively
              const processNestedChildren = c => {
                if (!c || _.isEmpty(c.children)) return undefined;
                return _.compact(
                  _.map(c.children, nestedChild => {
                    if (!nestedChild) return null;
                    return {
                      ...nestedChild,
                      isGradedStandard: _.has(nestedChild, "isGradedStandard")
                        ? _.get(nestedChild, "isGradedStandard")
                        : childIsGradedStandard,
                      children: processNestedChildren(nestedChild),
                    };
                  })
                );
              };

              return {
                ...child,
                isGradedStandard: childIsGradedStandard,
                children: processNestedChildren(child),
              };
            })
          );

          finalChildren = !_.isEmpty(processedChildren)
            ? processedChildren
            : undefined;
        } else {
          finalChildren = !_.isEmpty(standardChildren)
            ? standardChildren
            : undefined;
        }

        // Create the result with preserved properties
        return {
          ...(originalElement || {}),
          id: standard.id,
          label,
          levelId: _.get(originalElement, "levelId", 3),
          depth: _.get(originalElement, "depth", 3),
          ibPlannerElementType: elementType,
          type: elementType,
          code: _.get(originalElement, "code", _.get(standard, "code", "")),
          displaySequence: _.get(originalElement, "displaySequence", index + 1),
          isLeaf: _.get(originalElement, "isLeaf", _.isEmpty(finalChildren)),
          parent: _.get(originalElement, "parent", standardSetId),
          subText: _.get(
            originalElement,
            "subText",
            _.get(standard, "subText", "")
          ),
          subType: _.get(
            originalElement,
            "subType",
            _.get(standard, "subType", null)
          ),
          tags: _.get(originalElement, "tags", _.get(standard, "tags", [])),
          associatedParents: _.get(
            originalElement,
            "associatedParents",
            _.get(standard, "associatedParents", [])
          ),
          metadata: {
            draft_id: standard.id,
            parent_id: _.get(
              originalElement,
              "metadata.parent_id",
              standardSetId
            ),
            new_grades: _.get(originalElement, "metadata.new_grades", []),
            old_grades: _.get(originalElement, "metadata.old_grades", []),
            new_tags: _.get(originalElement, "metadata.new_tags", []),
            old_tags: _.get(originalElement, "metadata.old_tags", []),
          },
          isGradedStandard,
          children: finalChildren,
        };
      };

      // Build final result
      return _.compact(
        _.map(standardsBySetId, ({ standardSet, standards }) => {
          if (_.isEmpty(standards) || !standardSet || !standardSet.id)
            return null;

          const originalSetElement = _.find(elementList, {
            id: standardSet.id,
          });

          return {
            id: standardSet.id,
            label: standardSet.title,
            levelId: _.get(originalSetElement, "levelId", 0),
            depth: _.get(originalSetElement, "depth", 1),
            code: _.get(
              originalSetElement,
              "code",
              _.get(standardSet, "code", "")
            ),
            displaySequence: _.get(
              originalSetElement,
              "displaySequence",
              _.get(standardSet, "displaySequence", 1)
            ),
            isLeaf: _.get(originalSetElement, "isLeaf", false),
            type: elementType,
            ibPlannerElementType: elementType,
            metadata: {
              draft_id: standardSet.id,
              parent_id: null,
              new_grades: _.get(originalSetElement, "metadata.new_grades", []),
              old_grades: _.get(originalSetElement, "metadata.old_grades", []),
              new_tags: _.get(originalSetElement, "metadata.new_tags", []),
              old_tags: _.get(originalSetElement, "metadata.old_tags", []),
            },
            parent: _.get(originalSetElement, "parent", standardSet.id),
            subText: _.get(originalSetElement, "subText", ""),
            subType: _.get(originalSetElement, "subType", null),
            tags: _.get(originalSetElement, "tags", []),
            associatedParents: _.get(
              originalSetElement,
              "associatedParents",
              _.get(standardSet, "associatedParents", [])
            ),
            children: _.compact(
              _.map(
                _.filter(standards, standard => {
                  if (!standard || !standard.id) return false;
                  const isSelected = _.includes(selectedValues, standard.id);
                  const hasSelectedParent =
                    standard.parent &&
                    standard.parent !== standard.id &&
                    _.includes(selectedValues, standard.parent);
                  return isSelected && !hasSelectedParent;
                }),
                (standard, index) =>
                  processStandardElement(
                    standard,
                    elementMap[standard.id],
                    index,
                    standardSet.id,
                    standards
                  )
              )
            ),
          };
        })
      );
    };

    const getAIJustificationMessage = ({ type }) => {
      const elementListData = _.find(pypElementsData, { type });
      return _.reduce(
        elementListData?.elementList,
        (result, element) => {
          const justification = _.find(
            elementRemarks,
            remark => element?.id === remark?.ibPYPElementId
          );

          if (justification) {
            result.push({
              title: element?.label,
              justificationMsg: justification?.message,
            });
          }

          return result;
        },
        []
      );
    };

    const getIsAIResponseAccepted = ({ type }) => {
      return !_.some(ibPYPElementRatings, {
        creatorType: "AI",
        isDeleted: false,
        ibPYPElementType: type,
      });
    };

    return isEvaluatePypElement ? (
      <div
        className={classes.container}
        style={isJournalPostRating ? { marginBottom: "0px" } : containerStyle}
        ref={this.parentContainerRef}
      >
        {showDescriptiorModal && showCriteriaDescriptorButton && (
          <UIModal
            isOpen={showDescriptiorModal && showCriteriaDescriptorButton}
            modalContent={classes.descriptorModalContainer}
            onRequestClose={this.closeCriteriaDescriptorModal}
            overlayContainer={classes.descriptorModalOverlayContainer}
          >
            <RatingCriteriaDescriptor
              closeCriteriaDescriptorModal={this.closeCriteriaDescriptorModal}
              criteriaDescriptorState={criteriaDescriptorState}
              isNewGradingSetupEnabled={isNewGradingSetupEnabled}
            />
          </UIModal>
        )}
        {showToggleStudentPypEvaluateStatus && (
          <div className={classes.header}>
            <div
              onClick={
                isComplete || isDisabled
                  ? null
                  : () => toggleStudentPypEvaluateStatus(!evaluateIBPYPElements)
              }
            >
              <Checkbox
                isDisabled={isComplete || isDisabled}
                fill={colors.blue400}
                offFill={colors.strokeTwo}
                isChecked={evaluateIBPYPElements}
                style={{ width: 24, height: 24 }}
                checkBoxParentContainer={{
                  width: "max-content",
                  paddingTop: 0,
                }}
              />
            </div>
            <div className={classes.naLabel}>
              {t("assessmentEvaluation:evaluate_pyp_label_with_le", {
                label: getUserIdentifierName({
                  user: studentDetails,
                }),
              })}
            </div>
          </div>
        )}

        {evaluateIBPYPElements && (
          <div
            className={classes.evaluationContainer}
            style={evaluationContainerStyle}
          >
            {_.map(
              pypElementsData,
              (
                { levelType, elementList, type, label, plannerElementType },
                index
              ) => (
                <>
                  <DynamicLevelEvaluationBox
                    t={t}
                    key={type}
                    isComplete={isComplete}
                    plannerElementType={plannerElementType}
                    getStudentElementRatingValueOfCriteriaSet={params =>
                      getStudentElementRatingValueOfCriteriaSet({
                        ...params,
                        elementRatings,
                      })
                    }
                    levelType={levelType}
                    label={label}
                    rootStyle={pypRootLevelStyleMapping[type]}
                    createPypElementRating={params => {
                      if (studentDetails?.id || isAutoSaveDisabled) {
                        const elementRatingParams = {
                          ...params,
                          parentId,
                          parentType,
                          studentId: studentDetails?.id,
                          isPublished: isEvaluated,
                          curriculumProgramType,
                          ibPYPElementRatingsLocal,
                          setIBPYPElementRatingsLocal,
                          sourceFrom,
                          isAutoSaveDisabled,
                          learningCourseId: getIsCourseBasedGradingEnabled()
                            ? learningCourseId
                            : undefined,
                          getIsMediaManagerRoute,
                          setElementRatingMutationInProgress,
                        };
                        if (shouldAttachTermIdWithRating) {
                          elementRatingParams.academicTermId = academicTermId;
                        }
                        createIbPypElementRating(elementRatingParams);
                      }
                    }}
                    deletePypElementRating={params => {
                      if (studentDetails?.id || isAutoSaveDisabled) {
                        deletePypElementRating({
                          ...params,
                          parentId,
                          parentType,
                          academicTermId: shouldAttachTermIdWithRating
                            ? academicTermId
                            : undefined,
                          studentId: studentDetails?.id,
                          ibPYPElementRatingsLocal,
                          setIBPYPElementRatingsLocal,
                          isAutoSaveDisabled,
                          learningCourseId,
                        });
                      }
                    }}
                    type={type}
                    nodes={
                      getIsSubjectStandard({ type }) && isNewGradingSetupEnabled
                        ? processElementList({ elementList })
                        : elementList
                    }
                    getCriteriaSetOfPypType={this.getCriteriaSetOfPypType}
                    checkCriteriaSetOfPypTypeInLevels={params =>
                      checkCriteriaSetOfPypTypeInLevels({
                        ...params,
                      })
                    }
                    curriculumProgramType={curriculumProgramType}
                    subjectId={subjectId}
                    isMinimalDesign={isMinimalDesign}
                    updatePost={updatePost}
                    elementRatings={elementRatings}
                    postAllStudentRatings={postAllStudentRatings}
                    isJournalPostRating={isJournalPostRating}
                    studentId={_.get(studentDetails, "id", undefined)}
                    parentId={parentId}
                    updatePostRatingsCollectively={
                      updatePostRatingsCollectively
                    }
                    showCriteriaDescriptorButton={showCriteriaDescriptorButton}
                    criteriaDescriptorState={criteriaDescriptorState}
                    setCriteriaDescriptorState={this.setCriteriaDescriptorState}
                    parentContainerRef={this.parentContainerRef}
                    showCriteriaColumns={showCriteriaColumns}
                    showNodesIfCriteriaEmpty={showNodesIfCriteriaEmpty}
                    leftContainerStyle={leftContainerStyle}
                    customHeaderLabelStyle={customHeaderLabelStyle}
                    criteriaSetHeaderLabelPreviewStyle={
                      criteriaSetHeaderLabelPreviewStyle
                    }
                    infoIconSize={infoIconSize}
                    sourceFrom={sourceFrom}
                    evaluationBodyStyle={evaluationBodyStyle}
                    criteriaSetHeaderRowStyle={criteriaSetHeaderRowStyle}
                    rowContainerStyle={rowContainerStyle}
                    showCriteriaSetHeader={showCriteriaSetHeader}
                    rootContainerStyle={rootContainerStyle}
                    shouldCloseOnValueChange={shouldCloseOnValueChange}
                    evaluationContainerStyle={evaluationContainerStyle}
                    showDropdown={showDropdown}
                    updateIsTextFocus={this.updateIsTextFocus}
                    criteriaDescriptorIconStyle={criteriaDescriptorIconStyle}
                    subjectIds={subjectIds}
                    userId={userId}
                    showUpdatedDesign={showUpdatedDesign}
                    headerRowLeftContainerStyle={headerRowLeftContainerStyle}
                    showUnorderedList={showUnorderedList}
                    showRatingIfVisibleInViewPort={
                      showRatingIfVisibleInViewPort
                    }
                    isNewGradingSetupEnabled={isNewGradingSetupEnabled}
                    standards={this.props.standards}
                    assessmentFields={this.props.assessmentFields}
                    isGeneratingAIResponse={isGeneratingAIResponse}
                    academicTermId={academicTermId}
                    onAcceptAIEvaluation={onAcceptAIEvaluation}
                    learningCourseId={learningCourseId}
                    isAiEvaluationEnabled={isAiEvaluationEnabled}
                    isEvaluationModalView={isEvaluationModalView}
                    gradeScaleByPlannerElementType={
                      gradeScaleByPlannerElementType
                    }
                    plannerElementSetsByPlannerElementType={
                      plannerElementSetsByPlannerElementType
                    }
                    isCriteriaSetLoading={isCriteriaSetLoading}
                    gradeScaleDepthLevels={gradeScaleDepthLevels}
                  />
                  {!_.isEmpty(getAIJustificationMessage({ type })) &&
                  isAiEvaluationEnabled ? (
                    <div className={classes.aiJustificationContainer}>
                      <AIJustification
                        justifications={getAIJustificationMessage({ type })}
                        isAIGeneratingResponse={isGeneratingAIResponse}
                        headerTitle={"ai:ai_justification"}
                        isAIResponseAccepted={getIsAIResponseAccepted({
                          type,
                        })}
                      />
                    </div>
                  ) : null}

                  {index !== _.size(pypElementsData) - 1 && (
                    <div className={classes.divider} />
                  )}
                </>
              )
            )}
          </div>
        )}
      </div>
    ) : null;
  }
}

const getStudentElementRatingValueOfCriteriaSet = ({
  elementRatings,
  type,
  id,
  setId,
}) => {
  const elementRating = _.find(elementRatings, ratingObj => {
    return (
      ratingObj.ibPYPElementId == id &&
      ratingObj.ibPYPElementType == type &&
      ratingObj.academicCriteriaSet?.id == setId &&
      !ratingObj?.isDeleted
    );
  });

  return _.get(elementRating, "academicCriteriaValue.id", null);
};

const getPypElementsNestedData = ({
  values,
  resolvedMinimalTreeSet,
  type,
  assessmentFields,
  unitPlanFields,
  field_list,
  startDepth,
}) => {
  const nodeSet = getPYPElementSetFromNodes({
    nodes: resolvedMinimalTreeSet,
    startDepth,
  });
  const rootNodes = _.get(nodeSet, "rootNodes", []);
  const nodes = _.get(nodeSet, "nodes", []);

  switch (type) {
    case "CONCEPT":
    case "LEARNER_PROFILE":
    case "DP_LEARNER_PROFILE":
    case ELEMENT_TYPE_MYP_LEARNER_PROFILE:
    case "MYP_SPECIFIED_CONCEPTS":
      return {
        elementList: _.map(values, nodeId => {
          return _.find(nodes, { id: nodeId });
        }),
        levelType: "single",
      };
    case "LOI": {
      const { nodes } = getLinesOfInquiryNodes({
        unitPlanFields,
        assessmentFields,
        plannerElement: "lois",
        mode: "view",
      });
      return {
        elementList: nodes,
        levelType: "single",
      };
    }
    case "INQUIRY_QUESTIONS": {
      const { nodes } = getInquiryQuestionsNodes({
        unitPlanFields,
        assessmentFields,
        plannerElement: "inquiryQuestions",
        subFields: _.get(field_list, "inquiryQuestions.subFields"),
        mode: "view",
      });
      return {
        elementList: nodes,
        levelType: "multi",
      };
    }
    case "BENCHMARK":
    case "ATL":
    case "UBD_LEARNING_STANDARD":
    case ELEMENT_TYPE_MYP_LEARNING_STANDARD:
    case "DP_SUBJECT_STANDARD":
    case "DP_AIM":
    case "DP_OBJECTIVES":
    case ELEMENT_TYPE_DP_SYLLABUS:
    case ELEMENT_TYPE_MYP_OBJECTIVES:
    case ELEMENT_TYPE_MYP_KEY_CONCEPT:
    case ELEMENT_TYPE_MYP_RELATED_CONCEPT:
      return {
        elementList: generateNestedSelectedData({
          nodes,
          rootNodes,
          value: values,
          startDepth,
        }),
        levelType: "multi",
      };
    case "MYP_ATL":
    case "UBD_ATL":
    case "ACTION":
    case "DP_ATL":
      return {
        elementList: generateNestedSelectedData({
          nodes,
          rootNodes,
          value: values,
        }),
        levelType: "single",
      };
    default:
      return {};
  }
};

const mapActionCreators = {
  getCriteriaSetOfPypType,
  checkCriteriaSetOfPypTypeInLevels,
  createIbPypElementRating,
  deletePypElementRating,
  updatePost,
  updatePostRatingsCollectively,
  updateEvaluationData,
};

const getResolvedMinimalTreeSet = ({
  curriculumProgramType,
  assessmentField,
  elementKey,
}) => {
  switch (curriculumProgramType) {
    case CURRICULUM_TYPE_PYP:
      return _.get(
        assessmentField,
        `resolvedMinimalTree.${pypElementSetMapping[elementKey]}`,
        {}
      );
    default:
      return _.get(assessmentField, `resolvedMinimalTree.nodes`, {});
  }
};

const updatePlannerElementLabels = ({
  plannerElementsToEvaluate,
  curriculumProgramType,
  plannerElementSets,
  t,
}) => {
  const isNewGradingSetupEnabled = getIsNewGradingSetupEnabled();
  switch (curriculumProgramType) {
    case CURRICULUM_TYPE_UBD: {
      const updatedPlannerElementsToEvaluate = _.map(
        plannerElementsToEvaluate,
        element => {
          return {
            ...element,
            label: !_.isEmpty(plannerElementSets)
              ? plannerElementSets[pypElementMapping[element.value]]?.label
              : _.get(element, "label", ""),
          };
        }
      );
      return updatedPlannerElementsToEvaluate;
    }
    default: {
      const standardFieldKey = STANDARD_UIDS[curriculumProgramType];
      const updatedPlannerElementsToEvaluate = _.map(
        plannerElementsToEvaluate,
        element => {
          const { label, localeLabel, value } = element;
          const resolvedLabel = !_.isEmpty(localeLabel)
            ? t(localeLabel)
            : label;

          if (
            isNewGradingSetupEnabled &&
            value === standardFieldKey &&
            !_.isEmpty(plannerElementSets)
          ) {
            const elementType = FIELD_KEY_TO_PLANNER_ELEMENT_TYPE[value];
            const customLabel = plannerElementSets[elementType]?.label;
            if (customLabel) return { ...element, label: customLabel };
          }

          return { ...element, label: resolvedLabel };
        }
      );
      return updatedPlannerElementsToEvaluate;
    }
  }
};

const getPypElementsData = ({
  assessmentFields,
  curriculumProgramType,
  plannerElementSets,
  showAllElements,
  t,
  unitPlanFields,
  field_list,
  hideArchivedSubjectStandards,
  isNewGradingSetupEnabled,
  learningCourseId,
  isPypCurriculum,
  isJournalPostRating,
}) => {
  let plannerElementsToEvaluate = [];
  const assessmentDetails = { allFields: assessmentFields };
  if (showAllElements) {
    plannerElementsToEvaluate = getAllTaggableElements({
      curriculumProgramType,
      plannerElementSets,
      assessmentDetails,
      t,
      unitPlanFields,
    });
  } else {
    plannerElementsToEvaluate = getPlannerElementsToEvaluate({
      assessmentDetails,
      curriculumProgramType,
    });
  }

  const updatedPlannerElementToEvaluate = updatePlannerElementLabels({
    plannerElementsToEvaluate,
    curriculumProgramType,
    plannerElementSets,
    t,
  });

  const pypElementsData = _.map(updatedPlannerElementToEvaluate, pypElement => {
    const elementKey = pypElement.value;
    const type = pypElementMapping[elementKey];
    const plannerElementType = PLANNER_ELEMENT_FIELD_UID_MAP[elementKey];

    const assessmentField = _.find(assessmentFields, { uid: elementKey });

    const values = _.get(assessmentField, "value", []);
    let resolvedMinimalTreeSet = getResolvedMinimalTreeSet({
      curriculumProgramType,
      assessmentField,
      elementKey,
    });

    // Filter out subject standards for archived subjects
    if (hideArchivedSubjectStandards) {
      resolvedMinimalTreeSet = _.filter(
        resolvedMinimalTreeSet,
        node => !_.get(node, "resolvedSubject.isArchived", false)
      );
    }

    const { elementList = [], levelType = "" } = getPypElementsNestedData({
      values,
      resolvedMinimalTreeSet,
      type,
      assessmentFields,
      unitPlanFields,
      field_list,
      startDepth:
        isNewGradingSetupEnabled &&
        learningCourseId &&
        isPypCurriculum &&
        isJournalPostRating
          ? _.first(resolvedMinimalTreeSet)?.depth
          : undefined,
    });

    return {
      ...pypElement,
      elementList,
      levelType,
      type,
      plannerElementType,
    };
  });

  return getUpdatedPlannerElementsData({
    pypElementsData,
    isNewGradingSetupEnabled,
  });
};

const updatePlannerElementNode = ({ node, type }) => {
  let updatedNode = {
    ...node,
    ibPlannerElementType: type,
    levelId: _.get(node, "levelId") || _.get(node, "depth", 0),
  };
  if (!_.isEmpty(node?.children)) {
    const updatedChildren = _.map(updatedNode.children, child => {
      return updatePlannerElementNode({ node: child, type });
    });
    updatedNode = { ...updatedNode, children: updatedChildren };
  }
  return updatedNode;
};

const getSubjectType = ({ type }) => {
  switch (type) {
    case ELEMENT_TYPE_MYP_LEARNING_STANDARD:
      return ELEMENT_TYPE_MYP_SUBJECT;
    case ELEMENT_TYPE_UBD_LEARNING_STANDARD:
      return ELEMENT_TYPE_UBD_SUBJECT;
    case ELEMENT_TYPE_DP_SUBJECT_STANDARD:
      return ELEMENT_TYPE_DP_SUBJECT;
  }
};

//This function is to update the element nodes with ibPlannerElementType and levelId if it's not there
const getUpdatedPlannerElementNodes = ({ pypElementsData }) => {
  return _.map(pypElementsData, pypElement => {
    const ibPlannerElementType = _.get(pypElement, "type", "");
    const elementList = _.get(pypElement, "elementList", []);
    const updatedElementList = _.map(elementList, element => {
      return updatePlannerElementNode({
        node: element,
        type: ibPlannerElementType,
      });
    });

    return { ...pypElement, elementList: updatedElementList };
  });
};

//This will update the element nodes and then
//it will add subjectNode as a parent in UBD_LEARNING_STANDARD
const getUpdatedPlannerElementsData = ({
  pypElementsData,
  isNewGradingSetupEnabled,
}) => {
  const updatedPlannerElementTypeInNodes = getUpdatedPlannerElementNodes({
    pypElementsData,
  });
  let updatedElementList = [];
  const updatedPypElementsData = _.map(
    updatedPlannerElementTypeInNodes,
    pypElement => {
      let updatedPypElement = { ...pypElement };
      switch (pypElement.type) {
        case ELEMENT_TYPE_MYP_LEARNING_STANDARD:
        case ELEMENT_TYPE_DP_SUBJECT_STANDARD:
        case ELEMENT_TYPE_UBD_LEARNING_STANDARD: {
          const elementList = _.get(updatedPypElement, "elementList", []);
          if (!_.isEmpty(elementList)) {
            let subjectArray = [];
            //To Support different Subjects and Learning Standards in interdisciplinary Learning
            if (!isNewGradingSetupEnabled) {
              _.forEach(elementList, element => {
                const associatedParents = _.get(
                  element,
                  "associatedParents",
                  []
                );
                const associatedSubjectParent = _.find(
                  associatedParents,
                  parent => parent["__typename"] == "Subject"
                );

                const isAlreadyAddedSubject = _.find(
                  subjectArray,
                  subject =>
                    _.get(subject, "id") == _.get(associatedSubjectParent, "id")
                );
                if (!isAlreadyAddedSubject) {
                  subjectArray = _.compact([
                    ...subjectArray,
                    associatedSubjectParent,
                  ]);
                }
              });
              updatedElementList = _.map(subjectArray, subject => {
                const childrenElement = _.filter(elementList, element => {
                  const elementSubjectAssociatedParent = _.find(
                    _.get(element, "associatedParents", []),
                    parent => parent["__typename"] == "Subject"
                  );
                  return (
                    _.get(elementSubjectAssociatedParent, "id", "") ==
                    _.get(subject, "id", "")
                  );
                });
                return {
                  id: _.get(subject, "id"),
                  label: _.get(subject, "name"),
                  children: childrenElement,
                  levelId: 0,
                  type: getSubjectType({ type: pypElement.type }),
                  ibPlannerElementType: getSubjectType({
                    type: pypElement.type,
                  }),
                };
              });
            }
            updatedPypElement = {
              ...pypElement,
              elementList: isNewGradingSetupEnabled
                ? elementList
                : updatedElementList,
            };
          }
        }
      }
      return updatedPypElement;
    }
  );
  return updatedPypElementsData;
};

const getSubjectIds = _.memoize(
  course => {
    return _.map(_.get(course, "subjects", []), ({ id }) => id);
  },
  course => JSON.stringify(_.get(course, "subjects", []))
);

const mapStateToProps = (state, ownProps) => {
  const {
    assessmentFields,
    assessmentTools,
    ibPYPElementRatings,
    curriculumProgramType,
    course,
    showAllElements,
    t,
    unitPlanFields,
    field_list,
    hideArchivedSubjectStandards,
    parentId,
    learningCourseId: learningCourseIdFromProps,
    isJournalPostRating,
  } = ownProps;

  /* 
    Filtering out standards evaluation items which are already covered by a Standard Based Rubric tool to avoid showing duplicate view.
    CU: https://app.clickup.com/t/86d2fmut0
  */
  let filteredAssessmentFields = assessmentFields;
  if (!_.isNil(assessmentTools)) {
    const standardRubricCoveredNodeIds = getStandardRubricCoveredNodeIds({
      assessmentTools,
      isNewGradingSetupEnabled: getIsNewGradingSetupEnabled(),
    });
    filteredAssessmentFields = syncAssessmentFieldsWithStandardRubric({
      assessmentFields,
      standardRubricCoveredNodeIds,
    });
  }

  const grades = state.teacher.selected_class.selected_grades;
  const orgId = state.login.userInfo.org_id;
  const userId = state.login.userInfo.id;
  const plannerElementSets = _.get(
    state,
    "platform.currentPlannerElementSets",
    {}
  );
  const isNewGradingSetupEnabled = getIsNewGradingSetupEnabled();
  const learningCourseId =
    learningCourseIdFromProps || getSelectedLearningCourseId(state);
  const pypElementsData = getPypElementsData({
    assessmentFields: filteredAssessmentFields,
    curriculumProgramType,
    plannerElementSets,
    showAllElements,
    t,
    unitPlanFields,
    field_list,
    hideArchivedSubjectStandards,
    isNewGradingSetupEnabled,
    learningCourseId,
    isPypCurriculum: curriculumProgramType === CURRICULUM_TYPE_PYP,
    isJournalPostRating,
  });

  const organizationConstants = getOrganizationConstantsFromCache(orgId);
  const subjectIds = getSubjectIds(course);

  const curriculumProgramId = getSelectedCurriculumId(state);

  const subjectId = _.get(course, "subjects.0.id", "");

  const isGeneratingAIResponse = getIsAIGeneratingResponseForTool({
    state,
    studentAssignmentId: parentId,
    assessmentFields: filteredAssessmentFields,
  });

  const plannerElementTypes = _.map(pypElementsData, "plannerElementType");

  const plannerElementIds = _.compact(
    _.map(pypElementsData, el =>
      _.get(plannerElementSets, `${el.plannerElementType}.id`)
    )
  );

  return {
    elementRatings: ibPYPElementRatings,
    pypElementsData,
    grades,
    isEvaluatePypElement:
      organizationConstants.isEvaluatePypElement || isNewGradingSetupEnabled,
    isArchivedClass: _.get(state, "teacher.selected_class.isArchivedClass"),
    curriculumProgramType,
    plannerElementSets,
    subjectId,
    subjectIds,
    userId,
    learningCourseId,
    assessmentFields: filteredAssessmentFields,
    curriculumProgramId,
    isGeneratingAIResponse,
    isNewGradingSetupEnabled,
    isLearningCoursesEnabled: getIsLearningCoursesEnabled(),
    curriculumNodeInterfaceType: _.get(
      _.get(state, "platform.currentCurriculumProgram"),
      "nodeInterfaceType",
      ""
    ),
    orgId,
    plannerElementIds,
    plannerElementTypes,
  };
};

PypEvaluationV2.propTypes = {
  showToggleStudentPypEvaluateStatus: PropTypes.bool,
  isEvaluated: PropTypes.bool,
  isMinimalDesign: PropTypes.bool,
  isJournalPostRating: PropTypes.bool,
  showCriteriaDescriptorButton: PropTypes.bool,
  showAllElements: PropTypes.bool,
  showUpdatedDesign: PropTypes.bool,
  showUnorderedList: PropTypes.bool,
  showRatingIfVisibleInViewPort: PropTypes.bool,
  hideArchivedSubjectStandards: PropTypes.bool,
};

PypEvaluationV2.defaultProps = {
  showToggleStudentPypEvaluateStatus: true,
  isEvaluated: false,
  isMinimalDesign: false,
  isJournalPostRating: false,
  showCriteriaDescriptorButton: false,
  showAllElements: false,
  showUpdatedDesign: false,
  showUnorderedList: false,
  showRatingIfVisibleInViewPort: false,
  hideArchivedSubjectStandards: false,
};

export default compose(
  I18nHOC({ resource: ["assessmentEvaluation", "journal"] }),
  connect(mapStateToProps, mapActionCreators),
  graphql(getLearningCourseStandardsForRatingQuery, {
    name: "getLearningCourseStandardsForRating",
    skip: ({
      learningCourseId,
      curriculumProgramId,
      isNewGradingSetupEnabled,
      isLearningCoursesEnabled,
    }) =>
      !isNewGradingSetupEnabled ||
      !learningCourseId ||
      !curriculumProgramId ||
      !isLearningCoursesEnabled,
    options: ({
      learningCourseId,
      curriculumProgramId,
      curriculumProgramType,
    }) => ({
      variables: {
        id: learningCourseId,
        gradeScaleEntityDetailsFilters: {
          entityType: "CURRICULUM_PROGRAM",
          entityDetails: {
            curriculumProgramId: curriculumProgramId,
          },
        },
        plannerElementNodeFilters: {
          learningCourseIds: [learningCourseId],
        },
        isPYPCurriculum: curriculumProgramType === CURRICULUM_TYPE_PYP,
      },
      context: {
        useHttpLink: true,
      },
    }),
    props({
      getLearningCourseStandardsForRating: {
        node,
        loading: isLearningCourseStandardsLoading,
      },
    }) {
      const standardsEdge = _.get(node, "standardsWrapper.standardsEdge", []);
      const benchmarksEdge = _.get(node, "benchmarksWrapper.standardsEdge", []);
      // Use benchmarksWrapper for PYP curriculum, standardsWrapper for others
      const standards = _.isEmpty(benchmarksEdge)
        ? standardsEdge
        : benchmarksEdge;

      return {
        standards,
        isLearningCourseStandardsLoading,
      };
    },
  }),
  graphql(getCurriculumStandardsForRatingQuery, {
    name: "getCurriculumStandardsForRating",
    skip: ({
      curriculumProgramId,
      isNewGradingSetupEnabled,
      isLearningCoursesEnabled,
    }) =>
      !isNewGradingSetupEnabled ||
      !curriculumProgramId ||
      isLearningCoursesEnabled,
    options: ({ curriculumProgramId, curriculumProgramType }) => ({
      variables: {
        id: curriculumProgramId,
        gradeScaleEntityDetailsFilters: {
          entityType: "CURRICULUM_PROGRAM",
          entityDetails: {
            curriculumProgramId: curriculumProgramId,
          },
        },
        isPYPCurriculum: curriculumProgramType === CURRICULUM_TYPE_PYP,
      },
      context: {
        useHttpLink: true,
      },
    }),
    props({
      getCurriculumStandardsForRating: {
        node,
        loading: isCurriculumStandardsLoading,
      },
    }) {
      const standardEdges = _.get(node, "plannerElementNodeSets.edges", []);
      const standards = _.map(standardEdges, ({ node }) => ({
        standardSet: node,
      }));

      return { standards, isCurriculumStandardsLoading };
    },
  }),
  graphql(getPypPlannerElementNodesQuery, {
    name: "getPypPlannerElementNodes",
    skip: ({
      curriculumProgramId,
      isNewGradingSetupEnabled,
      curriculumProgramType,
      plannerElementTypes,
    }) =>
      !isNewGradingSetupEnabled ||
      !curriculumProgramId ||
      curriculumProgramType !== CURRICULUM_TYPE_PYP ||
      _.isEmpty(plannerElementTypes),
    options: ({ curriculumProgramId, plannerElementTypes }) => ({
      variables: {
        id: curriculumProgramId,
        type: NODE_TYPE_IB_PYP_CURRICULUM_PROGRAM,
        elementTypes: plannerElementTypes,
      },
      context: {
        useHttpLink: true,
      },
    }),
    props({
      getPypPlannerElementNodes: {
        node,
        loading: isPypPlannerElementNodesLoading,
      },
    }) {
      const plannerElementSets = _.get(node, "plannerElementSets", []);

      const plannerElementSetsByPlannerElementType = _.reduce(
        plannerElementSets,
        (acc, plannerElementSet) => {
          const { type, nodes } = plannerElementSet;

          acc[type] = _.keyBy(nodes, "id");
          return acc;
        },
        {}
      );

      return {
        plannerElementSetsByPlannerElementType,
        isPypPlannerElementNodesLoading,
      };
    },
  }),
  graphql(getPlannerElementNodesQuery, {
    name: "getPlannerElementNodes",
    skip: ({
      isNewGradingSetupEnabled,
      curriculumProgramType,
      plannerElementIds,
    }) =>
      !isNewGradingSetupEnabled ||
      curriculumProgramType === CURRICULUM_TYPE_PYP ||
      _.isEmpty(plannerElementIds),
    options: ({ plannerElementIds }) => ({
      variables: {
        ids: plannerElementIds,
      },
      context: {
        useHttpLink: true,
      },
    }),
    props({
      getPlannerElementNodes: {
        multiNode,
        loading: isPlannerElementNodesLoading,
      },
    }) {
      const plannerElementSetsByPlannerElementType = _.mapValues(
        _.keyBy(multiNode, "type"),
        ({ nodes }) => _.keyBy(nodes, "id")
      );

      return {
        plannerElementSetsByPlannerElementType,
        isPlannerElementNodesLoading,
      };
    },
  }),
  graphql(getDataSetQuery, {
    name: "getDataSetQuery",
    skip: ({
      plannerElementIds,
      curriculumProgramId,
      isNewGradingSetupEnabled,
    }) =>
      _.isEmpty(plannerElementIds) ||
      !isNewGradingSetupEnabled ||
      !curriculumProgramId,
    options: ({
      plannerElementIds,
      curriculumProgramId,
      curriculumNodeInterfaceType,
    }) => ({
      variables: {
        id: curriculumProgramId,
        type: curriculumNodeInterfaceType,
        filters: {
          plannerElementIds: plannerElementIds,
        },
      },
      context: {
        useHttpLink: true,
      },
    }),
    props({ getDataSetQuery: { node, loading: isDataSetQueryLoading } }) {
      const gradeScaleByPlannerElementType = parsePlannerElementSetsGradeScales(
        node
      );

      return {
        gradeScaleByPlannerElementType,
        isDataSetQueryLoading,
      };
    },
  })
)(PypEvaluationV2);
